export function getDatenschutzContent() {
  return (`
  <h5>Datenschutzerklärung</h5>
  <p>
    Diese Datenschutzerklärung klärt Sie über Art, Umfang und Zweck der Verarbeitung personenbezogener Daten
    (nachfolgend „Daten“) im Rahmen der Erbringung unserer Leistungen sowie innerhalb unseres Onlineangebotes
    und der damit verbundenen Webseiten, Funktionen und Inhalte sowie externen Onlinepräsenzen (z. B. unsere
    Social-Media-Profile) auf (nachfolgend zusammen „Onlineangebot“). Im Hinblick auf die verwendeten
    Begrifflichkeiten (z. B. „Verarbeitung“, „Verantwortlicher“) verweisen wir auf die Definitionen in Art. 4
    der Datenschutz-Grundverordnung (DSGVO).
  </p>
  
  <h5 id="dsg-general-controller">Verantwortlicher</h5>
  <p>
    <span class="tsmcontroller">
      SAB Saar, mit Sachverstand am Baum<br>
      Elke Lehnen<br>
      Danzigerstr. 13<br>
      D-66798 Wallerfangen<br>
      Mail: <a href="mailto:e.lehnen@sab-saar.com">e.lehnen@sab-saar.com</a><br>
      Impressum: <a href="http://sab-saar.com/impressum.html" target="_blank" rel="noopener">http://sab-saar.com/impressum.html</a>
    </span>
  </p>
  
  <h5 id="dsg-general-datatype">Arten der verarbeiteten Daten</h5>
  <ul>
    <li>Bestandsdaten (z. B. Personenstammdaten, Namen, Adressen)</li>
    <li>Kontaktdaten (z. B. E-Mail, Telefonnummern)</li>
    <li>Inhaltsdaten (z. B. Texteingaben, Fotografien, Videos)</li>
    <li>Nutzungsdaten (z. B. besuchte Webseiten, Interesse an Inhalten, Zugriffszeiten)</li>
    <li>Meta-/Kommunikationsdaten (z. B. Geräteinformationen, IP-Adressen)</li>
  </ul>
  
  <h5 id="dsg-general-datasubjects">Kategorien betroffener Personen</h5>
  <p>Besucher und Nutzer des Onlineangebotes (nachfolgend zusammenfassend „Nutzer“).</p>
  
  <h5 id="dsg-general-purpose">Zweck der Verarbeitung</h5>
  <ul>
    <li>Zurverfügungstellung des Onlineangebotes, seiner Funktionen und Inhalte</li>
    <li>Beantwortung von Kontaktanfragen und Kommunikation mit Nutzern</li>
    <li>Sicherheitsmaßnahmen</li>
    <li>Reichweitenmessung/Marketing</li>
  </ul>
  
  <h5 id="dsg-general-terms">Verwendete Begrifflichkeiten</h5>
  <p>
    „Personenbezogene Daten“ sind alle Informationen, die sich auf eine identifizierte oder identifizierbare
    natürliche Person (betroffene Person) beziehen; identifizierbar ist eine natürliche Person, die direkt oder
    indirekt, insbesondere mittels Zuordnung zu einer Kennung wie einem Namen, einer Kennnummer, Standortdaten,
    einer Online-Kennung (z. B. Cookie) oder zu einem oder mehreren besonderen Merkmalen identifiziert werden
    kann, die Ausdruck der physischen, physiologischen, genetischen, psychischen, wirtschaftlichen, kulturellen
    oder sozialen Identität dieser natürlichen Person sind.
  </p>
  <p>
    „Verarbeitung“ ist jeder mit oder ohne Hilfe automatisierter Verfahren ausgeführte Vorgang oder jede solche
    Vorgangsreihe im Zusammenhang mit personenbezogenen Daten.
  </p>
  <p>
    „Pseudonymisierung“ ist die Verarbeitung personenbezogener Daten in einer Weise, dass die personenbezogenen
    Daten ohne Hinzuziehung zusätzlicher Informationen nicht mehr einer spezifischen betroffenen Person
    zugeordnet werden können; diese zusätzlichen Informationen werden gesondert aufbewahrt und unterliegen
    technischen und organisatorischen Maßnahmen.
  </p>
  <p>
    „Profiling“ ist jede Art der automatisierten Verarbeitung personenbezogener Daten, mit der persönliche Aspekte
    bewertet werden (z. B. Arbeitsleistung, wirtschaftliche Lage, Gesundheit, Vorlieben, Verhalten, Aufenthaltsort).
  </p>
  <p>
    „Verantwortlicher“ ist die natürliche oder juristische Person, Behörde, Einrichtung oder andere Stelle, die
    allein oder gemeinsam mit anderen über Zwecke und Mittel der Verarbeitung von personenbezogenen Daten entscheidet.
  </p>
  <p>
    „Auftragsverarbeiter“ ist eine natürliche oder juristische Person, Behörde, Einrichtung oder andere Stelle,
    die personenbezogene Daten im Auftrag des Verantwortlichen verarbeitet.
  </p>
  
  <h5 id="dsg-general-legalbasis">Maßgebliche Rechtsgrundlagen</h5>
  <p>
    Nach Maßgabe des Art. 13 DSGVO teilen wir Ihnen die Rechtsgrundlagen unserer Datenverarbeitungen mit. Für Nutzer
    aus dem Geltungsbereich der DSGVO (EU/EWR) gilt, sofern die Rechtsgrundlage nicht ausdrücklich genannt wird:
  </p>
  <ul>
    <li>Einwilligung: Art. 6 Abs. 1 lit. a, Art. 7 DSGVO</li>
    <li>Vertrag/Anfrage: Art. 6 Abs. 1 lit. b DSGVO</li>
    <li>Rechtliche Verpflichtung: Art. 6 Abs. 1 lit. c DSGVO</li>
    <li>Lebenswichtige Interessen: Art. 6 Abs. 1 lit. d DSGVO</li>
    <li>Öffentliche Aufgabe/öffentliche Gewalt: Art. 6 Abs. 1 lit. e DSGVO</li>
    <li>Berechtigte Interessen: Art. 6 Abs. 1 lit. f DSGVO</li>
  </ul>
  <p>
    Die Verarbeitung von Daten zu anderen Zwecken als denen, zu denen sie erhoben wurden, richtet sich nach Art. 6
    Abs. 4 DSGVO. Die Verarbeitung besonderer Kategorien personenbezogener Daten richtet sich nach Art. 9 Abs. 2 DSGVO.
  </p>
  
  <h5 id="dsg-general-securitymeasures">Sicherheitsmaßnahmen</h5>
  <p>
    Wir treffen geeignete technische und organisatorische Maßnahmen, um ein dem Risiko angemessenes Schutzniveau
    zu gewährleisten (u. a. Vertraulichkeit, Integrität, Verfügbarkeit, Zugriffs- und Zugriffskontrollen,
    Verfahren zur Wahrnehmung von Betroffenenrechten, Löschung, Reaktion auf Gefährdungen, Datenschutz durch
    Technikgestaltung und datenschutzfreundliche Voreinstellungen).
  </p>
  
  <h5 id="dsg-general-coprocessing">Zusammenarbeit mit Auftragsverarbeitern, gemeinsam Verantwortlichen und Dritten</h5>
  <p>
    Eine Offenlegung/Übermittlung von Daten an andere Personen/Unternehmen erfolgt auf gesetzlicher Grundlage,
    bei Einwilligung, rechtlicher Verpflichtung oder aufgrund berechtigter Interessen (z. B. Beauftragte, Webhoster).
    Innerhalb der Unternehmensgruppe kann eine Übermittlung zu administrativen Zwecken auf gesetzlicher Grundlage
    und als berechtigtes Interesse erfolgen.
  </p>
  
  <h5 id="dsg-general-thirdparty">Übermittlungen in Drittländer</h5>
  <p>
    Eine Verarbeitung in Drittländern (außerhalb EU/EWR/CH) erfolgt auf Grundlage vertraglicher/gesetzlicher
    Pflichten, Einwilligung, rechtlicher Verpflichtung oder berechtigter Interessen und nur bei Vorliegen der
    gesetzlichen Voraussetzungen (z. B. angemessenes Datenschutzniveau oder geeignete Garantien).
  </p>
  
  <h5 id="dsg-general-rightssubject">Rechte der betroffenen Personen</h5>
  <ul>
    <li>Auskunft (inkl. Kopie), Art. 15 DSGVO</li>
    <li>Berichtigung/Vervollständigung, Art. 16 DSGVO</li>
    <li>Löschung bzw. Einschränkung der Verarbeitung, Art. 17/18 DSGVO</li>
    <li>Datenübertragbarkeit, Art. 20 DSGVO</li>
    <li>Beschwerde bei der zuständigen Aufsichtsbehörde, Art. 77 DSGVO</li>
  </ul>
  
  <h5 id="dsg-general-revokeconsent">Widerrufsrecht</h5>
  <p>Sie können Einwilligungen jederzeit mit Wirkung für die Zukunft widerrufen.</p>
  
  <h5 id="dsg-general-object">Widerspruchsrecht</h5>
  <p><strong>Sie können der künftigen Verarbeitung Ihrer Daten nach Maßgabe der gesetzlichen Vorgaben jederzeit widersprechen; insbesondere gegen Verarbeitung zu Zwecken der Direktwerbung.</strong></p>
  
  <h5 id="dsg-general-cookies">Cookies und Widerspruchsrecht bei Direktwerbung</h5>
  <p>
    „Cookies“ sind kleine Dateien, die auf Endgeräten gespeichert werden. Session-Cookies werden nach dem Besuch
    gelöscht; permanente Cookies bleiben gespeichert (z. B. Login-Status, Präferenzen). Third-Party-Cookies stammen
    von anderen Anbietern. Sie können Cookies in den Browsereinstellungen deaktivieren/löschen; dies kann die
    Funktionalität einschränken.
  </p>
  <p>
    Generelle Opt-out-Möglichkeiten für Online-Marketing-Cookies:
    <a href="https://www.aboutads.info/choices/" target="_blank" rel="noopener">aboutads.info/choices</a>,
    <a href="https://www.youronlinechoices.com/" target="_blank" rel="noopener">youronlinechoices.com</a>.
  </p>
  
  <h5 id="dsg-general-erasure">Löschung von Daten</h5>
  <p>
    Daten werden nach Maßgabe der gesetzlichen Vorgaben gelöscht oder in ihrer Verarbeitung eingeschränkt, sobald
    sie für den Zweck nicht mehr erforderlich sind und keine Aufbewahrungspflichten entgegenstehen. Besteht eine
    Pflicht zur Aufbewahrung, werden die Daten gesperrt und nicht für andere Zwecke verarbeitet.
  </p>
  
  <h5 id="dsg-general-changes">Änderungen und Aktualisierungen der Datenschutzerklärung</h5>
  <p>
    Bitte informieren Sie sich regelmäßig über den Inhalt dieser Datenschutzerklärung. Wir passen diese an, sobald
    Änderungen unserer Datenverarbeitungen dies erforderlich machen. Sofern eine Mitwirkungshandlung (z. B.
    Einwilligung) oder eine individuelle Benachrichtigung erforderlich wird, informieren wir Sie.
  </p>
  
  <!-- Ab hier: deine spezifischen Kapitel – sprachlich geglättet, Layout verbessert -->
  
  <h5 id="dsg-commercialpurpose">Geschäftsbezogene Verarbeitung</h5>
  <p class="ts-muster-content">
    Zusätzlich verarbeiten wir Vertragsdaten (z. B. Vertragsgegenstand, Laufzeit, Kundenkategorie) und Zahlungsdaten
    (z. B. Bankverbindung, Zahlungshistorie) unserer Kunden, Interessenten und Geschäftspartner zwecks Erbringung
    vertraglicher Leistungen, Service/Kundenpflege, Marketing, Werbung und Marktforschung.
  </p>
  
  <h5 id="dsg-services-agency">Agenturdienstleistungen</h5>
  <p class="ts-muster-content">
    Wir verarbeiten Kundendaten im Rahmen unserer vertraglichen Leistungen (u. a. Beratung, Kampagnenplanung,
    Software-/Designentwicklung und -pflege, Umsetzung, Serveradministration, Datenanalyse, Schulungen).
    Hierbei verarbeiten wir Bestands-, Kontakt-, Inhalts-, Vertrags-, Zahlungs-, Nutzungs- und Metadaten.
    Besondere Kategorien personenbezogener Daten verarbeiten wir grundsätzlich nicht, außer sie sind Teil des Auftrags.
    Löschung gemäß gesetzlichen Fristen (z. B. § 257 Abs. 1 HGB: 6 Jahre; § 147 Abs. 1 AO: 10 Jahre).
  </p>
  
  <h5 id="dsg-services-contractualservices">Vertragliche Leistungen</h5>
  <p class="ts-muster-content">
    Wir verarbeiten Daten unserer Vertragspartner (Art. 6 Abs. 1 lit. b DSGVO), um vertragliche bzw. vorvertragliche
    Leistungen zu erbringen. Dazu gehören Stammdaten, Kontaktdaten, Vertrags- und Zahlungsdaten. Im Rahmen unserer
    Onlinedienste können IP-Adresse und Zeitpunkt der Nutzerhandlung gespeichert werden (berechtigte Interessen,
    Missbrauchsprävention). Löschung nach Erforderlichkeit; gesetzliche Aufbewahrungsfristen bleiben unberührt.
  </p>
  
  <h5 id="dsg-services-payment">Externe Zahlungsdienstleister</h5>
  <p class="ts-muster-content">
    Wir setzen externe Zahlungsdienstleister ein (z. B. PayPal, Klarna, Skrill, Giropay, Visa, Mastercard,
    American Express). Die Verarbeitung erfolgt zur Vertragserfüllung (Art. 6 Abs. 1 lit. b DSGVO) bzw. aufgrund
    berechtigter Interessen (Art. 6 Abs. 1 lit. f DSGVO). Details entnehmen Sie bitte den Datenschutzhinweisen der
    jeweiligen Anbieter.
  </p>
  
  <h5 id="dsg-administration">Administration, Finanzbuchhaltung, Büroorganisation, Kontaktverwaltung</h5>
  <p class="ts-muster-content">
    Wir verarbeiten Daten im Rahmen von Verwaltungsaufgaben und zur Erfüllung gesetzlicher Pflichten
    (Art. 6 Abs. 1 lit. c, lit. f DSGVO). Dazu gehören u. a. Finanzverwaltung, Steuerberatung, Zahlungsdienstleister.
    Lieferanten-/Partnerdaten werden aus betriebswirtschaftlichen Interessen grundsätzlich dauerhaft gespeichert.
  </p>
  
  <h5 id="dsg-contact">Kontaktaufnahme</h5>
  <p class="ts-muster-content">
    Bei Kontaktaufnahme (z. B. per Formular, E-Mail, Telefon, Social Media) verarbeiten wir die Angaben der Nutzer
    zur Bearbeitung der Anfrage (Art. 6 Abs. 1 lit. b bzw. lit. f DSGVO). Löschung, sobald nicht mehr erforderlich;
    Prüfung der Erforderlichkeit mindestens alle zwei Jahre. Gesetzliche Archivierungspflichten bleiben unberührt.
  </p>
  
  <h5 id="dsg-socialmedia">Onlinepräsenzen in sozialen Medien</h5>
  <p class="ts-muster-content">
    Wir unterhalten Onlinepräsenzen in sozialen Netzwerken/Plattformen, um mit Nutzern zu kommunizieren und
    über Leistungen zu informieren. Datenverarbeitung kann außerhalb der EU erfolgen. Nutzungsprofile können zu
    Marktforschungs- und Werbezwecken erstellt werden (Cookies, geräteübergreifend). Rechtsgrundlage sind
    berechtigte Interessen (Art. 6 Abs. 1 lit. f DSGVO) bzw. Einwilligungen der Plattformanbieter (Art. 6 Abs. 1 lit. a DSGVO).
    Auskunfts-/Widerspruchsrechte sind am effektivsten direkt bei den Anbietern geltend zu machen.
  </p>
  
  <h5 id="dsg-thirdparty-einleitung">Einbindung von Diensten und Inhalten Dritter</h5>
  <p class="ts-muster-content">
    Wir setzen Inhalte/Services Dritter (z. B. Videos, Schriftarten) auf Grundlage berechtigter Interessen
    (Art. 6 Abs. 1 lit. f DSGVO) ein. Dafür ist die Übermittlung der IP-Adresse an den Drittanbieter erforderlich.
    Drittanbieter können Pixel-Tags zu Statistik-/Marketingzwecken einsetzen; dabei können pseudonyme Informationen
    in Cookies gespeichert und mit anderen Quellen verknüpft werden.
  </p>
  
  <h5 id="dsg-thirdparty-youtube">YouTube</h5>
  <p class="ts-muster-content">
    Wir binden Videos der Plattform „YouTube“ (Google LLC) ein.
    Datenschutzerklärung:
    <a href="https://policies.google.com/privacy" target="_blank" rel="noopener">https://policies.google.com/privacy</a>,
    Opt-out:
    <a href="https://adssettings.google.com/authenticated" target="_blank" rel="noopener">https://adssettings.google.com/authenticated</a>.
  </p>
  
  <h5 id="dsg-thirdparty-googlefonts">Google Fonts</h5>
  <p class="ts-muster-content">
    Wir binden Schriftarten („Google Fonts“) des Anbieters Google LLC ein.
    Datenschutzerklärung:
    <a href="https://policies.google.com/privacy" target="_blank" rel="noopener">https://policies.google.com/privacy</a>,
    Opt-out:
    <a href="https://adssettings.google.com/authenticated" target="_blank" rel="noopener">https://adssettings.google.com/authenticated</a>.
  </p>
  
  <h5 id="dsg-facebook-plugin">Verwendung von Facebook Social Plugins</h5>
  <p class="ts-muster-content">
    Wir nutzen Social Plugins („Plugins“) von Facebook (Facebook Ireland Ltd.) auf Grundlage berechtigter Interessen
    (Art. 6 Abs. 1 lit. f DSGVO). Durch Einbindung kann Facebook Daten erheben/verarbeiten (auch IP-Adresse).
    Details zu Zweck, Umfang, Rechten und Einstellungen:
    <a href="https://www.facebook.com/about/privacy/" target="_blank" rel="noopener">https://www.facebook.com/about/privacy/</a>.
  </p>
  
  <p class="mt-3">
    <a href="https://datenschutz-generator.de" class="dsg1-6" target="_blank" rel="nofollow noopener">
      Erstellt mit Datenschutz-Generator.de von RA Dr. Thomas Schwenke
    </a>
  </p>  
  `);
}

/**
 *  GALK BAUMLISTE
 *
 * @type {*} */
export function getGalkListContent() {
  return `<table id="galkListTable" class='table table-striped display compact hover '>

  <thead>
      <tr>
          <th class="td_center">Botanischer und deutscher Name</th>
          <th class="td_center">Wuchshöhe</th>
          <th class="td_center">Breite in m</th>
          <th class="td_center">Lichtdurchlässigkeit</th>
          <th class="td_center">Lichtbedarf</th>
          <th class="td_center">Verwendbarkeit</th>
          <th class="td_center">Bemerkungen</th>
      </tr>
  </thead>
  <tbody>

      <tr id="tr159" class="tr_edit">
          <td>Acer buergerianum
              <br>syn. A. trifidum, Dreizahn-Ahorn, Dreispitz-Ahorn</td>
          <td>8-10&nbsp;(15)</td>
          <td>4-6</td>
          <td>mittel</td>
          <td><img src="img/l_2_t.gif" border="0"></td>
          <td>noch im Test</td>
          <td>kompakte, rundliche Krone, locker verzweigte Äste, auf geschützten Standorten ausreichend frosthart, gebietsweise frostempfindlich, für enge Straßenbereiche geeignet, im
              <b>Straßenbaumtest 2</b>
              seit 2007/08</td>
      </tr>
      <tr id="tr1" class="tr_edit">
          <td>Acer campestre, Feldahorn, Maßholder</td>
          <td>10-15&nbsp;(20)</td>
          <td>10-15</td>
          <td>mittel</td>
          <td><img src="img/l_2_t.gif" border="0"></td>
          <td>geeignet mit E.</td>
          <td>eiförmige, unregelmäßige, im Alter mehr rundliche Krone, verträgt trockene Böden und hohen Versiegelungsgrad, guter Bodenbefestiger für Ufer bzw. Hanglagen, Bienenweide</td>
      </tr>
      <tr id="tr2" class="tr_edit">
          <td>Acer campestre 'Elsrijk', Feldahorn</td>
          <td>6-12&nbsp;(15)</td>
          <td>4-6</td>
          <td>mittel</td>
          <td><img src="img/l_2_t.gif" border="0"></td>
          <td>geeignet</td>
          <td>wie die Art, jedoch gerader durchgehender Stamm, im Wuchs schmaler und gleichmäßiger, gebietsweise Frostschäden in der Krone, mehltaufrei, Bienenweide</td>
      </tr>
      <tr id="tr160" class="tr_edit">
          <td>Acer campestre 'Huibers Elegant'
              <br>syn. A. campestre 'Elegant', Feldahorn</td>
          <td>6-10</td>
          <td>3-5</td>
          <td>mittel</td>
          <td><img src="img/l_2_t.gif" border="0"></td>
          <td>noch im Test</td>
          <td>sehr regelmäßiger, aufrechter Wuchs, gilt als mehltaufrei, Bienenweide, im
              <b>Straßenbaumtest 2</b>
              seit 2007/08</td>
      </tr>
      <tr id="tr3" class="tr_edit">
          <td>Acer monspessulanum, Französischer Ahorn, Burgen-Ahorn, Dreilappiger Ahorn</td>
          <td>5-8&nbsp;(11)</td>
          <td>4-7&nbsp;(9)</td>
          <td>mittel</td>
          <td><img src="img/l_2_t.gif" border="0"></td>
          <td>noch im Test</td>
          <td>breit eiförmige, rundlicher Krone, auf geraden, durchgehenden Stamm achten;
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                       wärmeliebend, für trockene Standorte geeignet (Weinbauklima), gebietsweise Frostschäden, langsam wachsend, Bienenweide, im
              <b>Straßenbaumtest 2</b>
              seit 2005
          </td>
      </tr>
      <tr id="tr162" class="tr_edit">
          <td>Acer opalus, Schneeball-Ahorn</td>
          <td>8-10&nbsp;(20)</td>
          <td>5-8</td>
          <td>mittel</td>
          <td><img src="img/l_1_t.gif" border="0"></td>
          <td>noch im Test</td>
          <td>offene, breite, kegelförmige Krone, stadtklimafest, Bienenweide, im
              <b>Straßenbaumtest 2</b>
              seit 2007/08</td>
      </tr>
      <tr id="tr4" class="tr_edit">
          <td>Acer platanoides, Spitzahorn</td>
          <td>20-30</td>
          <td>15-22</td>
          <td>gering</td>
          <td><img src="img/l_2_t.gif" border="0"></td>
          <td>geeignet mit E.</td>
          <td>rundliche, dicht geschlossene Krone, blüht vor dem Blattaustrieb, sehr frosthart, empfindlich gegen Bodenverdichtung und Streusalz, Honigtauabsonderung, Bienenweide
          </td>
      </tr>
      <tr id="tr5" class="tr_edit">
          <td>Acer platanoides 'Allershausen', Spitzahorn</td>
          <td>15-20</td>
          <td>-10</td>
          <td>gering</td>
          <td><img src="img/l_2_t.gif" border="0"></td>
          <td>geeignet</td>
          <td>stark verzweigte, dichte, geschlossene Krone, gut geeignet für frostgefährdete Lagen, Honigtauabsonderung, Bienenweide, im
              <b>Straßenbaumtest 2</b>
              seit 2005

          </td>
      </tr>
      <tr id="tr6" class="tr_edit">
          <td>Acer platanoides 'Apollo', Kegelförmiger Spitzahorn</td>
          <td>14-18</td>
          <td>10-15</td>
          <td>gering</td>
          <td><img src="img/l_2_t.gif" border="0"></td>
          <td>geeignet mit E.</td>
          <td>wie die Art, jedoch aufrechter und schneller wachsend, gebietsweise frostempfindlich, Honigtauabsonderung, Bienenweide, im
              <b>Straßenbaumtest 2</b>
              seit 2005
          </td>
      </tr>
      <tr id="tr7" class="tr_edit">
          <td>Acer platanoides 'Cleveland', Kegelförmiger Spitzahorn</td>
          <td>10-15</td>
          <td>7-9</td>
          <td>gering</td>
          <td><img src="img/l_2_t.gif" border="0"></td>
          <td>geeignet</td>
          <td>ovale, im Alter breit eiförmige, regelmäßige Krone, Austrieb leuchtend rot, stadtklimafest, sehr frosthart, Honigtauabsonderung, Bienenweide</td>
      </tr>
      <tr id="tr8" class="tr_edit">
          <td>Acer platanoides 'Columnare', Säulenförmiger Spitzahorn</td>
          <td>-10&nbsp;(16)</td>
          <td>2-7</td>
          <td>gering</td>
          <td><img src="img/l_2_t.gif" border="0"></td>
          <td>geeignet</td>
          <td>schmaler als die Art, säulenförmig wachsend, sehr frosthart, hitzeverträglich, trockenheitsverträglich, windfest und schattenverträglich, Honigtauabsonderung, guter Kompartimentierer, Bienenweide</td>
      </tr>
      <tr id="tr11" class="tr_edit">
          <td>Acer platanoides 'Deborah', Spitzahorn</td>
          <td>15-20</td>
          <td>10-15</td>
          <td>gering</td>
          <td><img src="img/l_2_t.gif" border="0"></td>
          <td>geeignet mit E.</td>
          <td>kegel- bis eiförmige Krone, Äste aufrecht wachsend, gerader durchgehender Stamm, in der Jugend gebietsweise Trocken- und Frostschäden, Honigtauabsonderung, Bienenweide,
              <b>Ergebnisse aus Straßenbaumtest 1</b>
              beachten</td>
      </tr>
      <tr id="tr12" class="tr_edit">
          <td>Acer platanoides 'Emerald Queen', Spitzahorn</td>
          <td>-15</td>
          <td>8-10</td>
          <td>gering</td>
          <td><img src="img/l_2_t.gif" border="0"></td>
          <td>geeignet mit E.</td>
          <td>ovale Krone, in der Jugend betont aufrecht, hitze- und trockenheitsverträglich, gebietsweise frostgefährdet, windfest, geeignet für engere Straßenräume, Honigtauabsonderung, Bienenweide</td>
      </tr>
      <tr id="tr163" class="tr_edit">
          <td>Acer platanoides 'Fairview', Spitzahorn</td>
          <td>13-15</td>
          <td>-10</td>
          <td>gering</td>
          <td><img src="img/l_2_t.gif" border="0"></td>
          <td>noch im Test</td>
          <td>aufrechte ovale Krone; anspruchslos und anpassungsfähig, hitzeverträglich und frosthart, Honigtauabsonderung, Bienenweide, im
              <b>Straßenbaumtest 2</b>
              seit 2007/08</td>
      </tr>
      <tr id="tr13" class="tr_edit">
          <td>Acer platanoides 'Farlake's Green', Spitzahorn</td>
          <td>15-20</td>
          <td>10-15</td>
          <td>gering</td>
          <td><img src="img/l_2_t.gif" border="0"></td>
          <td>geeignet mit E.</td>
          <td>kegel- bis eiförmige Krone, gleichmäßig aufgebaut, gebietsweise Frost- und Trockenheitsempfindlich, windfest, wenig mehltauanfällig, empfindlich gegen Streusalz (Erfahrungen aus NL), Bienenweide,
              <a href="http://strassenbaumtest1.galk.de/" target="_blank">
                  <b>Ergebnisse aus Straßenbaumtest 1</b>
              </a>
              beachten
          </td>
      </tr>
      <tr id="tr14" class="tr_edit">
          <td>Acer platanoides 'Globosum', Kugelspitzahorn</td>
          <td>-6</td>
          <td>5-8</td>
          <td>gering</td>
          <td><img src="img/l_2_t.gif" border="0"></td>
          <td>geeignet</td>
          <td>dicht verzweigte, geschlossene Kugelkrone, auf Lichtraumprofil achten, frosthart, hitze- und trockenheitsverträglich, windfest und schattenverträglich, Honigtauabsonderung, für Kübel und Container geeignet, Bienenweide</td>
      </tr>
      <tr id="tr17" class="tr_edit">
          <td>Acer platanoides 'Olmsted', Spitzahorn</td>
          <td>10-12&nbsp;(15)</td>
          <td>2-3</td>
          <td>gering</td>
          <td><img src="img/l_2_t.gif" border="0"></td>
          <td>geeignet</td>
          <td>schmal, säulenförmig; geeignet für enge Räume in exponierter, lufttrockener Stadtlage; entspricht vermutlich Typ 1 von Acer platanoides 'Columnare', Honigtauabsonderung, Bienenweide</td>
      </tr>
      <tr id="tr15" class="tr_edit">
          <td>Acer platanoides 'Royal Red', Rotblättriger Spitzahorn</td>
          <td>-15&nbsp;(20)</td>
          <td>8-10</td>
          <td>gering</td>
          <td><img src="img/l_2_t.gif" border="0"></td>
          <td>geeignet mit E.</td>
          <td>Laub im Austrieb rot, danach bis zum Herbst konstant purpurschwarzrot, glänzend, sehr frosthart, hitzeverträglich, windfest, Honigtauabsonderung, Bienenweide</td>
      </tr>
      <tr id="tr18" class="tr_edit">
          <td>Acer pseudoplatanus, Bergahorn</td>
          <td>25-30&nbsp;(40)</td>
          <td>15-20&nbsp;(25)</td>
          <td>gering</td>
          <td><img src="img/l_2_t.gif" border="0"></td>
          <td>nicht geeignet</td>
          <td>kalkverträglich, streusalzempfindlich, nicht geeignet bei Bodenverdichtungen und hohem Versiegelungsgrad, Honigtauabsonderung, Bienenweide</td>
      </tr>
      <tr id="tr186" class="tr_edit">
          <td>Acer pseudoplatanus 'Bruchem', Bergahorn</td>
          <td>20-25</td>
          <td>5-15</td>
          <td>gering</td>
          <td><img src="img/l_2_t.gif" border="0"></td>
          <td>geeignet mit E.</td>
          <td>anfangs kompakt, schmal säulenförmig, später pyramidal bis eiförmig, durchgehender Leittrieb, dunkelgrüne Belaubung, auffallende Blüte, Bienenweide, rötlich gefärbte Früchte</td>
      </tr>
      <tr id="tr19" class="tr_edit">
          <td>Acer pseudoplatanus 'Erectum', Schmaler Bergahorn</td>
          <td>15-20&nbsp;(25)</td>
          <td>6-8&nbsp;(10)</td>
          <td>gering</td>
          <td><img src="img/l_2_t.gif" border="0"></td>
          <td>nicht geeignet</td>
          <td>wie die Art, jedoch in der Jugend schmalkroniger, Honigtauabsonderung, Bienenweide</td>
      </tr>
      <tr id="tr20" class="tr_edit">
          <td>Acer pseudoplatanus 'Negenia', Bergahorn</td>
          <td>20-25&nbsp;(30)</td>
          <td>10-15</td>
          <td>gering</td>
          <td><img src="img/l_2_t.gif" border="0"></td>
          <td>nicht geeignet</td>
          <td>wie die Art, jedoch mit breit pyramidaler Krone, vergreist früh, Honigtauabsonderung, Bienenweide
          </td>
      </tr>
      <tr id="tr21" class="tr_edit">
          <td>Acer pseudoplatanus 'Rotterdam', Bergahorn
          </td>
          <td>20-25&nbsp;(30)</td>
          <td>10-12&nbsp;(15)</td>
          <td>gering</td>
          <td><img src="img/l_2_t.gif" border="0"></td>
          <td>nicht geeignet</td>
          <td>wie die Art, in der Jugend säulenförmig, später breit kegelförmig, keine Leittriebbildung, Honigtauabsonderung, Bienenweide</td>
      </tr>
      <tr id="tr22" class="tr_edit">
          <td>Acer rubrum, Rotahorn</td>
          <td>10-15&nbsp;(20)</td>
          <td>6-10&nbsp;(14)</td>
          <td>gering</td>
          <td><img src="img/l_2_t.gif" border="0"></td>
          <td>geeignet mit E.</td>
          <td>dunkelrote Blüte vor Blattaustrieb, frosthart, etwas hitzeempfindlich, bedingt stadtklimafest, flach wurzelnd, auf Kalkböden Chlorosegefahr, Bienenweide</td>
      </tr>
      <tr id="tr189" class="tr_edit">
          <td>Acer rubrum 'Redpointe'
              <br>syn. A. rubrum var. 'Tomentosum, A. rubrum 'Frank jr. Redpoint', Rotahorn</td>
          <td>10-15</td>
          <td>10-12</td>
          <td>gering</td>
          <td><img src="img/l_1_t.gif" border="0"></td>
          <td>noch im Test</td>
          <td>wie die Art, jedoch geschlossenere, kegelförmige Krone, durchgehender Leittrieb, auf Kalkböden Chlorosegefahr, rote Blüte vor dem Austrieb im März/April, intensive hellrote Herbstfärbung, Bienenweide, im
              <b>Straßenbaumtest 2</b>
              seit 2022</td>
      </tr>
      <tr id="tr24" class="tr_edit">
          <td>Acer rubrum 'Scanlon', Schmalkroniger Rotahorn</td>
          <td>10-12</td>
          <td>3-4</td>
          <td>gering</td>
          <td><img src="img/l_1_t.gif" border="0"></td>
          <td>noch im Test</td>
          <td>wie die Art, jedoch schmal eiförmige Krone, rote Blüte vor Blattaustrieb, Bienenweide, im
              <b>Straßenbaumtest 2</b>
              seit 2007/08</td>
      </tr>
      <tr id="tr25" class="tr_edit">
          <td>Acer saccharinum
              <br>syn. A. dasycarpum, Silberahorn</td>
          <td>25-30</td>
          <td>20-25</td>
          <td>stark</td>
          <td><img src="img/l_1_t.gif" border="0"></td>
          <td>nicht geeignet</td>
          <td>windbrüchig, kurzlebig, jedoch schnelle Wirkung, auf Kalkböden Chlorosegefahr, sehr früh blühend, Bienenweide</td>
      </tr>
      <tr id="tr190" class="tr_edit">
          <td>Acer truncatum 'Norwegian Sunset'
              <br>syn A. truncatum x platanoides 'Keithsform', A. platanoides 'Norway Sunset', Chinesischer Spitzahorn</td>
          <td>10-12</td>
          <td>6-8</td>
          <td>mittel</td>
          <td><img src="img/l_2_t.gif" border="0"></td>
          <td>noch im Test</td>
          <td>rundliche Krone, Kreuzung zwischen A. truncatum und A. platanoides; dadurch weniger anfällig gegen Hitze, Trockenheit und Bodenverdichtung als A. platanoides, auffällige Herbstfärbung, Bienenweide, im
              <b>Straßenbaumtest 2</b>
              seit 2022</td>
      </tr>
      <tr id="tr23" class="tr_edit">
          <td>Acer x freemanii 'Armstrong'
              <br>syn. A. rubrum 'Armstrong', Schmalkroniger Rotahorn</td>
          <td>10-15&nbsp;(20)</td>
          <td>-5&nbsp;(7)</td>
          <td>gering</td>
          <td><img src="img/l_1_t.gif" border="0"></td>
          <td>geeignet mit E.</td>
          <td>schmale Krone, gerader durchgehender Stamm, rotorange Blüte vor Blattaustrieb; auf Kalkböden Chlorosegefahr, Bienenweide</td>
      </tr>
      <tr id="tr161" class="tr_edit">
          <td>Acer x freemanii 'Autumn Blaze', Ahorn</td>
          <td>15-20</td>
          <td>12-15</td>
          <td>gering</td>
          <td><img src="img/l_2_t.gif" border="0"></td>
          <td>noch im Test</td>
          <td>zunächst stark aufrechter Wuchs, später ovale Kronenform; gilt als frosthart, stadtklimafest, Bienenweide, im
              <b>Straßenbaumtest 2</b>
              seit 2007/08</td>
      </tr>
      <tr id="tr165" class="tr_edit">
          <td>Acer x zoechense
              <br>syn. A. neglectum 'Annae', Zoeschener Ahorn</td>
          <td>4-6&nbsp;(8)</td>
          <td>4-6</td>
          <td>gering</td>
          <td><img src="img/l_2_t.gif" border="0"></td>
          <td>&nbsp;</td>
          <td>schwachwachsender, kleiner Baum, Lichtraumprofil schwer einzuhalten, hitzeverträglich, auffallende Herbstfärbung, Bienenweide, für Straßenbaumtest 2 vorgesehen</td>
      </tr>
      <tr id="tr28" class="tr_edit">
          <td>Aesculus hippocastanum, Rosskastanie</td>
          <td>-25&nbsp;(30)</td>
          <td>15-20&nbsp;(25)</td>
          <td>gering</td>
          <td><img src="img/l_1_t.gif" border="0"></td>
          <td>geeignet mit E.</td>
          <td>empfindlich gegen Streusalz, Fruchtfall beachten, starker Kronen- und Wurzeldruck, Bienenweide; Risiko einer Komplexerkrankung, die zum Ausfall der Bäume führen kann. Besonders betroffen sind Bäume mit Vorschädigungen und reduzierter Vitalität.</td>
      </tr>
      <tr id="tr29" class="tr_edit">
          <td>Aesculus hippocastanum  'Baumannii', Gefüllt-blühende Rosskastanie</td>
          <td>-25&nbsp;(30)</td>
          <td>15-20&nbsp;(25)</td>
          <td>gering</td>
          <td><img src="img/l_1_t.gif" border="0"></td>
          <td>geeignet mit E.</td>
          <td>wie die Art, jedoch länger und gefüllt blühend, keine Fruchtbildung, Risiko einer Komplexerkrankung, die zum Ausfall der Bäume führen kann. Besonders betroffen sind Bäume mit Vorschädigungen und reduzierter Vitalität.</td>
      </tr>
      <tr id="tr26" class="tr_edit">
          <td>Aesculus x carnea, Rotblühende Kastanie, Purpurkastanie</td>
          <td>10-15&nbsp;(20)</td>
          <td>8-12&nbsp;(16)</td>
          <td>gering</td>
          <td><img src="img/l_2_t.gif" border="0"></td>
          <td>geeignet mit E.</td>
          <td>schwierig aufzuasten, nicht geeignet bei Bodenverdichtungen und hohem Versiegelungsgrad, geringer Befall durch Miniermotte, geringer Fruchtfall, Bienenweide, Risiko einer Komplexerkrankung, die zum Ausfall der Bäume führen kann. Besonders betroffen sind Bäume mit Vorschädigungen und reduzierter Vitalität.</td>
      </tr>
      <tr id="tr27" class="tr_edit">
          <td>Aesculus x carnea 'Briotii', Scharlachkastanie</td>
          <td>10-15</td>
          <td>8-12</td>
          <td>gering</td>
          <td><img src="img/l_2_t.gif" border="0"></td>
          <td>geeignet mit E.</td>
          <td>wie die Art, jedoch kräftiger gefärbte Blüte, in verschiedenen Typen im Handel, Bienenweide; Risiko einer Komplexerkrankung, die zum Ausfall der Bäume führen kann. Besonders betroffen sind Bäume mit Vorschädigungen und reduzierter Vitalität.</td>
      </tr>
      <tr id="tr30" class="tr_edit">
          <td>Ailanthus altissima
              <br>syn. A. glandulosum, Götterbaum</td>
          <td>20-25</td>
          <td>10-15&nbsp;(20)</td>
          <td>mittel</td>
          <td><img src="img/l_1_t.gif" border="0"></td>
          <td>nicht geeignet</td>
          <td>außerordentlich schnellwüchsig, starke Ausbreitungstendenz, Windbruchgefahr, sehr trockenheitsverträglich, wärmeliebend, salztolerant, besonders stadtklimafest, Bienenweide, seit 2019 in Europa als invasive Art gekennzeichnet

          </td>
      </tr>
      <tr id="tr31" class="tr_edit">
          <td>Alnus cordata, Italienische Erle</td>
          <td>10-15&nbsp;(20)</td>
          <td>8-10</td>
          <td>mittel</td>
          <td><img src="img/l_1_t.gif" border="0"></td>
          <td>geeignet mit E.</td>
          <td>treibt früh aus, deshalb gelegentlich spätfrostgefährdet, industrie- und stadtklimafest, sehr windverträglich, Schneebruchgefahr durch lang haftendes Laub
          </td>
      </tr>
      <tr id="tr32" class="tr_edit">
          <td>Alnus glutinosa, Schwarzerle</td>
          <td>10-20&nbsp;(25)</td>
          <td>8-12&nbsp;(14)</td>
          <td>mittel</td>
          <td><img src="img/l_1_t.gif" border="0"></td>
          <td>nicht geeignet</td>
          <td>windfest, stickstoffbindend, schnelle Laubverrottung, sehr tief gehendes Wurzelsystem, nicht geeignet bei Bodenverdichtungen und hohem Versiegelungsgrad, Bienenweide</td>
      </tr>
      <tr id="tr33" class="tr_edit">
          <td>Alnus incana, Grauerle, Weißerle</td>
          <td>6-10&nbsp;(20)</td>
          <td>4-8&nbsp;(12)</td>
          <td>mittel</td>
          <td><img src="img/l_1_t.gif" border="0"></td>
          <td>geeignet mit E.</td>
          <td>anspruchslos, sehr frosthart, windresistent, salztolerant, Stickstoffsammler; 
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      wurzelt flacher als Alnus glutinosa, bildet Ausläufer, Bienenweide
          </td>
      </tr>
      <tr id="tr34" class="tr_edit">
          <td>Alnus x spaethii, Erle, Purpurerle
          </td>
          <td>12-15</td>
          <td>8-10</td>
          <td>mittel</td>
          <td><img src="img/l_1_t.gif" border="0"></td>
          <td>gut geeignet</td>
          <td>kegel- bis eiförmige Krone, Äste aufrecht bis überhängend wachsend, frosthart, windfest, schnell wachsend, gerader, durchgehender Stamm, teilweise starker Fruchtbehang, Schneebruchgefahr durch lang haftendes Laub, Bienenweide,
              <a href="http://strassenbaumtest1.galk.de/" target="_blank">
                  <b>Ergebnisse aus Straßenbaumtest 1</b>
              </a>
              beachten</td>
      </tr>
      <tr id="tr35" class="tr_edit">
          <td>Amelanchier arborea 'Robin Hill', Felsenbirne</td>
          <td>6-8</td>
          <td>3-5</td>
          <td>mittel</td>
          <td><img src="img/l_2_t.gif" border="0"></td>
          <td>geeignet</td>
          <td>breit eiförmige Krone, früh blühend und angenehm duftend, für Kübel und Container geeignet, Bienenweide, im
              <b>Straßenbaumtest 2</b>
              seit 2005</td>
      </tr>
      <tr id="tr36" class="tr_edit">
          <td>Betula papyrifera, Papierbirke</td>
          <td>18-25</td>
          <td>7-12</td>
          <td>stark</td>
          <td><img src="img/l_1_t.gif" border="0"></td>
          <td>geeignet mit E.</td>
          <td>pyramidale Krone, kurzlebig, nicht stadtklimafest, nicht in befestigten Flächen verwenden, Pflanzzeitpunkt beachten</td>
      </tr>
      <tr id="tr37" class="tr_edit">
          <td>Betula pendula
              <br>syn. B. verrucosa, Sandbirke, Weißbirke</td>
          <td>18-25&nbsp;(30)</td>
          <td>10-15&nbsp;(18)</td>
          <td>stark</td>
          <td><img src="img/l_1_t.gif" border="0"></td>
          <td>geeignet mit E.</td>
          <td>lockere, hochgewölbte Krone, Seitenbezweigung oft lang herunterhängend, frosthart, nicht stadtklimafest, neigt zur Anhebung von Belägen, nicht in befestigten Flächen verwenden, Pflanzzeitpunkt beachten, Bienenweide

          </td>
      </tr>
      <tr id="tr38" class="tr_edit">
          <td>Betula utilis
              <br>syn. B. jacquemontii, Schneebirke</td>
          <td>8-10&nbsp;(15)</td>
          <td>5-7</td>
          <td>stark</td>
          <td><img src="img/l_1_t.gif" border="0"></td>
          <td>geeignet mit E.</td>
          <td>aufrecht wachsend, auffallend weiße Rinde, Wurzeln flach ausgebreitet, hoher Anteil an Feinwurzeln in der oberen Bodenzone, Pflanzzeitpunkt beachten</td>
      </tr>
      <tr id="tr39" class="tr_edit">
          <td>Carpinus betulus, Hainbuche, Weißbuche</td>
          <td>10-20&nbsp;(25)</td>
          <td>7-12&nbsp;(15)</td>
          <td>gering</td>
          <td><img src="img/l_3_t.gif" border="0"></td>
          <td>geeignet mit E.</td>
          <td>kegelförmig, im Alter hochgewölbt, nicht stadtklimafest, daher nicht in befestigten Flächen verwenden</td>
      </tr>
      <tr id="tr40" class="tr_edit">
          <td>Carpinus betulus 'Fastigiata', Pyramiden-Hainbuche</td>
          <td>15-20</td>
          <td>4-6&nbsp;(10)</td>
          <td>gering</td>
          <td><img src="img/l_3_t.gif" border="0"></td>
          <td>geeignet</td>
          <td>säulen- bis kegelförmige Krone, im Alter auseinanderfallend, weniger hitze- und strahlungsempfindlich als die Art, für Kübel und Container geeignet</td>
      </tr>
      <tr id="tr41" class="tr_edit">
          <td>Carpinus betulus 'Frans Fontaine', Säulen-Hainbuche</td>
          <td>10-15</td>
          <td>4-5</td>
          <td>gering</td>
          <td><img src="img/l_2_t.gif" border="0"></td>
          <td>geeignet mit E.</td>
          <td>wie Carpinus betulus 'Fastigiata', jedoch auch im Alter säulenförmig, Krone in der Jugend nicht ganz geschlossen, sehr windfest, vermehrt Spätfrostschäden an den Stämmen der Jungbäume, für Kübel und Container geeignet
          </td>
      </tr>
      <tr id="tr185" class="tr_edit">
          <td>Carpinus betulus 'Lucas', Säulen-Hainbuche</td>
          <td>10-12</td>
          <td>-2</td>
          <td>gering</td>
          <td><img src="img/l_2_t.gif" border="0"></td>
          <td>noch im Test</td>
          <td>schmaler und kompakter als Carpinus betulus 'Frans Fontaine', dadurch auch in engeren Straßenbereichen einzusetzen, dunkelgrünes, festes Laub, im
              <b>Straßenbaumtest 2</b>
              seit 20018</td>
      </tr>
      <tr id="tr42" class="tr_edit">
          <td>Catalpa bignonioides, Trompetenbaum, Amerikanischer Trompetenbaum</td>
          <td>8-10&nbsp;(15)</td>
          <td>6-10</td>
          <td>mittel</td>
          <td><img src="img/l_2_t.gif" border="0"></td>
          <td>geeignet mit E.</td>
          <td>rundliche Krone und weit ausladenden Seitenästen, artbedingt kein durchgehender Leittrieb; auffallende Blüten, Blätter und Früchte, gebietsweise frostgefährdet, auf Lichtraumprofil achten, Bienenweide
          </td>
      </tr>
      <tr id="tr43" class="tr_edit">
          <td>Celtis australis, Südlicher oder Europäischer Zürgelbaum</td>
          <td>10-20</td>
          <td>10-15</td>
          <td>mittel</td>
          <td><img src="img/l_1_t.gif" border="0"></td>
          <td>geeignet mit E.</td>
          <td>ausladend, rund, schirmförmige Krone, Stammbildung besser als bei Celtis occidentalis, Wärme liebend und für trockene Standorte geeignet (Weinbauklima), gebietsweise frostgefährdet, Bienenweide</td>
      </tr>
      <tr id="tr44" class="tr_edit">
          <td>Celtis occidentalis, Abendländischer oder Amerikanischer Zürgelbaum</td>
          <td>10-20</td>
          <td>10-15</td>
          <td>mittel</td>
          <td><img src="img/l_1_t.gif" border="0"></td>
          <td>nicht geeignet</td>
          <td>breit ausladend, Äste überhängend, geringe Bodenanforderungen, trockenheitsverträglich, Lichtraumprofil sehr schwer zu erreichen, gebietsweise Verwilderung</td>
      </tr>
      <tr id="tr45" class="tr_edit">
          <td>Cercis siliquastrum, Gemeiner Judasbaum</td>
          <td>4-6</td>
          <td>4-6</td>
          <td>gering</td>
          <td><img src="img/l_1_t.gif" border="0"></td>
          <td>geeignet mit E.</td>
          <td>runde, breit ausladende Krone, wärmeliebend (Weinbauklima), gebietsweise frostgefährdet, für trockene Standorte geeignet, auf geraden Leittrieb achten, Bienenweide</td>
      </tr>
      <tr id="tr181" class="tr_edit">
          <td>Cornus mas, Kornelkirsche, Gelber Hartriegel, Herlitze, Dirlitze</td>
          <td>5-6&nbsp;(8)</td>
          <td>3-5</td>
          <td>mittel</td>
          <td><img src="img/l_2_t.gif" border="0"></td>
          <td>geeignet mit E.</td>
          <td>kleinkronige, sehr zeitig blühende Bäume, für enge Straßenräume und Kübelpflanzung  geeignet, Stämme mit abblätternder Borke, anspruchslos, nicht frostempfindlich, stadtklimafest, Bienenweide, Fruchtfall beachten, Lichtraumprofil beachten, für Straßenbaumtest 2 vorgesehen</td>
      </tr>
      <tr id="tr46" class="tr_edit">
          <td>Corylus colurna, Baumhasel, Türkische Hasel</td>
          <td>15-18&nbsp;(23)</td>
          <td>8-12&nbsp;(16)</td>
          <td>gering</td>
          <td><img src="img/l_2_t.gif" border="0"></td>
          <td>geeignet mit E.</td>
          <td>regelmäßige, breit- kegelförmige Krone; anspruchslos, stadtklimafest, in manchen Jahren starker Fruchtfall, Bienenweide</td>
      </tr>
      <tr id="tr47" class="tr_edit">
          <td>Crataegus crus-galli
              <br>syn. C. prunifolia 'Splendens', C. persimilis 'Splendens', Hahnendorn, Pflaumenblättriger Weißdorn</td>
          <td>5-7&nbsp;(9)</td>
          <td>5-7&nbsp;(9)</td>
          <td>mittel</td>
          <td><img src="img/l_2_t.gif" border="0"></td>
          <td>geeignet mit E.</td>
          <td>breit-runde Krone, besonders lange Dornen, frosthart, windfest, Lichtraumprofil beachten, für Kübel und Container geeignet, Bienenweide</td>
      </tr>
      <tr id="tr48" class="tr_edit">
          <td>Crataegus laevigata 'Paul's Scarlet'
              <br>syn. C. monogyna 'Kermesina Plena', Echter Rotdorn</td>
          <td>4-6&nbsp;(8)</td>
          <td>4-6&nbsp;(8)</td>
          <td>mittel</td>
          <td><img src="img/l_1_t.gif" border="0"></td>
          <td>geeignet mit E.</td>
          <td>regelmäßige, breit- kegelförmige Krone, gefüllt blühend, anspruchslos, nicht zu trocken, Lichtraumprofil beachten, für Kübel und Container geeignet</td>
      </tr>
      <tr id="tr49" class="tr_edit">
          <td>Crataegus lavallei 'Carrierei'
              <br>syn. C. carrierei, Apfeldorn</td>
          <td>5-7</td>
          <td>5-7</td>
          <td>mittel</td>
          <td><img src="img/l_1_t.gif" border="0"></td>
          <td>geeignet mit E.</td>
          <td>breit- kegelförmige Krone, Triebe mit starken  Dornen, lang haftendes, ledrig glänzendes, dunkelgrünes Laub, Lichtraumprofil beachten, für Kübel und Container geeignet, Bienenweide</td>
      </tr>
      <tr id="tr50" class="tr_edit">
          <td>Crataegus monogyna 'Stricta', Säulenweißdorn</td>
          <td>5-7&nbsp;(10)</td>
          <td>2-3</td>
          <td>mittel</td>
          <td><img src="img/l_2_t.gif" border="0"></td>
          <td>geeignet mit E.</td>
          <td>straff aufrecht bis säulenförmig, im Alter auseinanderfallend, Triebe mit Dornen behaftet, anfällig für Feuerbrand und Rost, Lichtraumprofil beachten, für Kübel und Container geeignet, Bienenweide</td>
      </tr>
      <tr id="tr51" class="tr_edit">
          <td>Crataegus x prunifolia
              <br>syn. C. x persimilus, Pflaumenblättriger Weißdorn</td>
          <td>6-7</td>
          <td>5-6</td>
          <td>mittel</td>
          <td><img src="img/l_1_t.gif" border="0"></td>
          <td>geeignet mit E.</td>
          <td>wie Crataegus grus-gallii, glänzendes, dunkelgrünes Laub, frosthart, stadtklimafest, anfällig für Feuerbrand und Rost, Bienenweide</td>
      </tr>
      <tr id="tr166" class="tr_edit">
          <td>Eriolobus trilobatus
              <br>syn. Malus trilobata, Dreilappiger Apfel</td>
          <td>6-8</td>
          <td>3-5</td>
          <td>mittel</td>
          <td><img src="img/l_2_t.gif" border="0"></td>
          <td>noch im Test</td>
          <td>pyramidal aufrecht wachsender kleiner Baum, schorffrei, Bienenweide, im
              <b>Straßenbaumtest 2</b>
              seit 2007/08</td>
      </tr>
      <tr id="tr191" class="tr_edit">
          <td>Eucommia ulmoides, Chinesischer Guttaperchabaum, Gummiulme</td>
          <td>15-20</td>
          <td>8-12</td>
          <td>stark</td>
          <td><img src="img/l_2_t.gif" border="0"></td>
          <td>noch im Test</td>
          <td>ausladender Wuchs, der entsprechenden Schnitt verlangt, monotypisch, zweihäusig, geflügelte Nussfrüchtea, anspruchslos, Bodenversiegelung vermeiden, im
              <b>Straßenbaumtest 2</b>
              seit 2022</td>
      </tr>
      <tr id="tr167" class="tr_edit">
          <td>Fraxinus americana 'Autumn Purple'
              <br>syn. Fraxinus americana 'Junginger', Weißesche</td>
          <td>15-18</td>
          <td>12-15</td>
          <td>stark</td>
          <td><img src="img/l_1_t.gif" border="0"></td>
          <td>noch im Test</td>
          <td>männliche Selektion, ohne Früchte; auffallende Herbstfärbung, bisher noch noch kein Eschentriebsterben zu beobachten, Laubentfernung mindert den Befallsdruck, im
              <b>Straßenbaumtest 2</b>
              seit 2007/08</td>
      </tr>
      <tr id="tr53" class="tr_edit">
          <td>Fraxinus angustifolia 'Raywood'
              <br>syn. F. oxyacarpa 'Flame',  F. oxyacarpa 'Raywood', Schmalblättrige Esche</td>
          <td>10-15&nbsp;(20)</td>
          <td>10-15</td>
          <td>stark</td>
          <td><img src="img/l_2_t.gif" border="0"></td>
          <td>geeignet mit E.</td>
          <td>hitzeverträglich und Wärme liebend, gebietsweise frostempfindlich, stadtklimafest, ohne Früchte, auffallende Herbstfärbung, Bienenweide, bisher noch kein Eschentriebsterben zu beobachten, Laubentfernung mindert den Befallsdruck</td>
      </tr>
      <tr id="tr54" class="tr_edit">
          <td>Fraxinus excelsior, Gemeine Esche</td>
          <td>25-35&nbsp;(40)</td>
          <td>20-25&nbsp;(30)</td>
          <td>stark</td>
          <td><img src="img/l_2_t.gif" border="0"></td>
          <td>geeignet mit E.</td>
          <td>rundliche, lichte Krone, weit ausladend, später Austrieb, früher Laubfall, empfindlich gegen Oberflächenverdichtung, Laubentfernung mindert den Befallsdruck bei Eschentriebsterben</td>
      </tr>
      <tr id="tr55" class="tr_edit">
          <td>Fraxinus excelsior 'Altena'
              <br>syn. F. excelsior 'Monarch', Esche</td>
          <td>15-20</td>
          <td>10-12</td>
          <td>stark</td>
          <td><img src="img/l_2_t.gif" border="0"></td>
          <td>geeignet mit E.</td>
          <td>wie die Art, jedoch schlanker und regelmäßiger, Zweige aufstrebend, gerader, durchgehender Stamm, empfindlich gegen Oberflächenverdichtung und Trockenheit, bisher noch kein Eschentriebsterben zu beobachten;  Laubentfernung mindert den Befallsdruck</td>
      </tr>
      <tr id="tr56" class="tr_edit">
          <td>Fraxinus excelsior 'Atlas', Esche</td>
          <td>15-20</td>
          <td>10-15</td>
          <td>stark</td>
          <td><img src="img/l_2_t.gif" border="0"></td>
          <td>geeignet mit E.</td>
          <td>Kegel- bis eiförmige Krone, Äste aufrecht wachsend, Wärme liebend, hitzeverträglich, Regional in unterschiedlichem Maße Trockenschäden, dadurch erhöhter Schnittaufwand, bisher noch kein Eschentriebsterben zu beobachten;  Laubentfernung mindert den Befallsdruck,
              <a href="http://strassenbaumtest1.galk.de/" target="_blank">
                  <b>Ergebnisse aus Straßenbaumtest 1</b>
              </a>
              beachten
          </td>
      </tr>
      <tr id="tr57" class="tr_edit">
          <td>Fraxinus excelsior 'Diversifolia'
              <br>syn. F. excelsior 'Monophylla', Einblättrige Esche</td>
          <td>10-18</td>
          <td>6-12</td>
          <td>stark</td>
          <td><img src="img/l_2_t.gif" border="0"></td>
          <td>geeignet mit E.</td>
          <td>kegel- bis eiförmige, teils säulenförmige Krone, locker und unregelmäßig, aufrechter Wuchs, stadtklimafest, windfest, Regional in unterschiedlichem Maße Trockenschäden, vereinzelt Frostschäden, dadurch erhöhter Schnittaufwand bei Eschentriebsterben, Laubentfernung mindert den Befallsdruck,
              <a href="http://strassenbaumtest1.galk.de/" target="_blank">
                  <b>Ergebnisse aus Straßenbaumtest 1</b>
              </a>
              beachten
          </td>
      </tr>
      <tr id="tr58" class="tr_edit">
          <td>Fraxinus excelsior 'Geessink', Esche</td>
          <td>15-20</td>
          <td>10-12</td>
          <td>stark</td>
          <td><img src="img/l_2_t.gif" border="0"></td>
          <td>geeignet</td>
          <td>wie die Art, jedoch schmaler und schwächer wachsend, sehr windbeständig, kaum spätfrostgefährdet, Laubentfernung mindert den Befallsdruck bei Eschentriebsterben</td>
      </tr>
      <tr id="tr59" class="tr_edit">
          <td>Fraxinus excelsior 'Globosa '
              <br>syn. F. excelsior 'Nana', Kugelesche</td>
          <td>3-5</td>
          <td>3-5</td>
          <td>mittel</td>
          <td><img src="img/l_2_t.gif" border="0"></td>
          <td>geeignet</td>
          <td>wie die Art, jedoch klein und kugelförmig, mit dicht verzweigter Krone, langsam wachsend, Lichtraumprofil beachten, für Kübel und Container geeignet, Laubentfernung mindert den Befallsdruck bei Eschentriebsterben</td>
      </tr>
      <tr id="tr60" class="tr_edit">
          <td>Fraxinus excelsior 'Westhof's Glorie', Nichtfruchtende Straßenesche</td>
          <td>20-25&nbsp;(30)</td>
          <td>12-15</td>
          <td>stark</td>
          <td><img src="img/l_2_t.gif" border="0"></td>
          <td>geeignet</td>
          <td>wie die Art, jedoch sehr später Laubaustrieb, deshalb kaum spätfrostgefährdet, gerader, durchgehender Stamm, Laubentfernung mindert den Befallsdruck bei Eschentriebsterben</td>
      </tr>
      <tr id="tr61" class="tr_edit">
          <td>Fraxinus ornus, Blumenesche, Manna - Esche</td>
          <td>8-12&nbsp;(15)</td>
          <td>6-8&nbsp;(10)</td>
          <td>stark</td>
          <td><img src="img/l_1_t.gif" border="0"></td>
          <td>geeignet</td>
          <td>schwachwüchsig, stadtklimafest, selten gerader Leittrieb, auf Lichtraumprofil achten, nicht in befestigten Flächen verwenden, schöne Blüte, Bienenweide, kein Befall mit Eschentriebsterben
          </td>
      </tr>
      <tr id="tr182" class="tr_edit">
          <td>Fraxinus  ornus 'Louisa Lady', Blumenesche</td>
          <td>8-10&nbsp;(12)</td>
          <td>4-5</td>
          <td>mittel</td>
          <td><img src="img/l_2_t.gif" border="0"></td>
          <td>noch im Test</td>
          <td>wie die Art, jedoch mit offen ovaler Krone, Blüte mit großen Blütenständen, Bienenweide, keine Früchte, kein Befall mit Eschentriebsterben, im
              <b>Straßenbaumtest 2</b>
              seit 2015</td>
      </tr>
      <tr id="tr168" class="tr_edit">
          <td>Fraxinus ornus 'Mecsek', Kugelförmige Blumenesche, Manna - Esche</td>
          <td>5-6</td>
          <td>3-4</td>
          <td>mittel</td>
          <td><img src="img/l_2_t.gif" border="0"></td>
          <td>geeignet mit E.</td>
          <td>klein, kugelförmig, sehr genügsam, stadtklimafest, auf Lichtraumprofil achten, auffällige Blüte, Bienenweide, kein Befall mit Eschentriebsterben, im
              <b>Straßenbaumtest 2</b>
              seit 2007/08</td>
      </tr>
      <tr id="tr62" class="tr_edit">
          <td>Fraxinus ornus 'Rotterdam', Blumenesche, Manna - Esche</td>
          <td>8-12</td>
          <td>6-8</td>
          <td>mittel</td>
          <td><img src="img/l_1_t.gif" border="0"></td>
          <td>geeignet</td>
          <td>wie die Art, jedoch mit regelmäßiger und kegelförmiger Krone, durchgehendem Leittrieb, trockenheits- und hitzeverträglich, nicht in befestigten Flächen verwenden, für Kübel und Container geeignet, auffällige Blüte, Bienenweide, kein Befall mit Eschentriebsterben</td>
      </tr>
      <tr id="tr63" class="tr_edit">
          <td>Fraxinus pennsylvanica, Rotesche, Grünesche</td>
          <td>15-20</td>
          <td>10-15</td>
          <td>stark</td>
          <td><img src="img/l_2_t.gif" border="0"></td>
          <td>noch im Test</td>
          <td>teils pyramidale, teils breit eiförmige Krone, im Alter ausladend, gerader, durchgehender Stamm, Wärme liebend und hitzeverträglich, trockenheitverträglich, stadtklimafest, Bienenweide, kein Befall mit Eschentriebsterben, im
              <b>Straßenbaumtest 2</b>
              seit 2005</td>
      </tr>
      <tr id="tr183" class="tr_edit">
          <td>Fraxinus  pennsylvanica  'Summit', Rotesche</td>
          <td>14-16</td>
          <td>5-7</td>
          <td>stark</td>
          <td><img src="img/l_2_t.gif" border="0"></td>
          <td>noch im Test</td>
          <td>regelmäßig aufgebaute Krone, anfangs oval, im Alter rundlich, durchgehender Stamm, tief wurzelnd, schöne Herbstfärbung, Bienenweide, kein Befall mit Eschentriebsterben, im
              <b>Straßenbaumtest 2</b>
              seit 2015</td>
      </tr>
      <tr id="tr64" class="tr_edit">
          <td>Ginkgo biloba, Ginkgobaum, Fächerbaum</td>
          <td>15-30&nbsp;(35)</td>
          <td>10-15&nbsp;(20)</td>
          <td>stark</td>
          <td><img src="img/l_1_t.gif" border="0"></td>
          <td>geeignet mit E.</td>
          <td>anspruchslos, stadtklimafest, frei von Schädlingen, hoher Lichtanspruch, schöne Herbstfärbung, zweihäusig
          </td>
      </tr>
      <tr id="tr66" class="tr_edit">
          <td>Ginkgo biloba 'Fastigiata Blagon', Säulen - Fächerbaum</td>
          <td>15-20</td>
          <td>4-6</td>
          <td>stark</td>
          <td><img src="img/l_2_t.gif" border="0"></td>
          <td>geeignet mit E.</td>
          <td>schmal kegelförmig, zweihäusig, Fruchtfall der weiblichen Exemplare beachten, schöne Herbstfärbung, im
              <b>Straßenbaumtest 2</b>
              von 2005 bis 2016</td>
      </tr>
      <tr id="tr65" class="tr_edit">
          <td>Ginkgo biloba 'Princeton Sentry', Säulen - Fächerblattbaum</td>
          <td>15-20</td>
          <td>4-6</td>
          <td>stark</td>
          <td><img src="img/l_2_t.gif" border="0"></td>
          <td>noch im Test</td>
          <td>sehr regelmäßige und geschlossene Krone, schwachwüchsig, schöne Herbstfärbung, im
              <b>Straßenbaumtest 2</b>
              seit 2005</td>
      </tr>
      <tr id="tr67" class="tr_edit">
          <td>Gleditsia triacanthos, Gleditschie, Lederhülsenbaum, Falscher Christusdorn</td>
          <td>15-20&nbsp;(25)</td>
          <td>10-15</td>
          <td>stark</td>
          <td><img src="img/l_1_t.gif" border="0"></td>
          <td>nicht geeignet</td>
          <td>lockere, breite schirmförmige Krone, kein durchgehender Leittrieb, anspruchslos, stadtklimafest, breite, lange lederartige Hülsenfrüchte, Bienenweide, Verkehrsgefahr durch Dornen am Stamm und Abwurf im Alter
          </td>
      </tr>
      <tr id="tr68" class="tr_edit">
          <td>Gleditsia triacanthos 'Inermis', Dornenlose Gleditschie</td>
          <td>10-25</td>
          <td>8-15&nbsp;(20)</td>
          <td>stark</td>
          <td><img src="img/l_1_t.gif" border="0"></td>
          <td>geeignet</td>
          <td>wie die Art, jedoch dornlose Sorte, bei der in Einzelfällen nachträglich Dornen gebildet werden können, Bienenweide</td>
      </tr>
      <tr id="tr69" class="tr_edit">
          <td>Gleditsia triacanthos 'Shademaster', Dornenlose Gleditschie</td>
          <td>10-15&nbsp;(20)</td>
          <td>10-15</td>
          <td>stark</td>
          <td><img src="img/l_1_t.gif" border="0"></td>
          <td>geeignet</td>
          <td>wie die Art, jedoch dornlose Sorte, bei der in Einzelfällen nachträglich Dornen gebildet werden können, später Laubfall, Bienenweide</td>
      </tr>
      <tr id="tr70" class="tr_edit">
          <td>Gleditsia triacanthos 'Skyline', Dornenlose Gleditschie</td>
          <td>10-15&nbsp;(20)</td>
          <td>10-15</td>
          <td>stark</td>
          <td><img src="img/l_1_t.gif" border="0"></td>
          <td>gut geeignet</td>
          <td>wie die Art, Krone mit ausladenden Ästen, dornenlose Sorte, bei der in Einzelfällen nachträglich Dornen gebildet werden können, keine Früchte, Bienenweide</td>
      </tr>
      <tr id="tr71" class="tr_edit">
          <td>Gleditsia triacanthos 'Sunburst', Gold - Gleditschie</td>
          <td>8-10</td>
          <td>6-8</td>
          <td>stark</td>
          <td><img src="img/l_1_t.gif" border="0"></td>
          <td>geeignet mit E.</td>
          <td>wie die Art, jedoch dornenlos, hellgelber Austrieb, später gelbgrün, auf Lichtraumprofil achten, Bienenweide</td>
      </tr>
      <tr id="tr72" class="tr_edit">
          <td>Koelreuteria paniculata, Blasenbaum, Blasenesche, Lampionbaum</td>
          <td>6-8</td>
          <td>6-8</td>
          <td>stark</td>
          <td><img src="img/l_1_t.gif" border="0"></td>
          <td>geeignet mit E.</td>
          <td>breite Krone, langsam wachsend, kein durchgehender Leittrieb, auf Lichtraumprofil achten, auffallende Blüten und Fruchtstände, Bienenweide, gebietsweise verwildernd, im
              <b>Straßenbaumtest 2</b>
              seit 2005</td>
      </tr>
      <tr id="tr73" class="tr_edit">
          <td>Liquidambar styraciflua, Amberbaum</td>
          <td>10-20&nbsp;(30)</td>
          <td>6-12</td>
          <td>mittel</td>
          <td><img src="img/l_1_t.gif" border="0"></td>
          <td>geeignet</td>
          <td>stark variierende, im Alter offene Krone, kalkempfindlich, lang anhaltende Herbstfärbung, sofern sonniger Sandort und kalte Nächte, lang haftendes Laub und Früchte, auffallende Korkleisten, Bienenweide</td>
      </tr>
      <tr id="tr74" class="tr_edit">
          <td>Liquidambar styraciflua 'Moraine', Amberbaum</td>
          <td>10-20</td>
          <td>6-12</td>
          <td>mittel</td>
          <td><img src="img/l_2_t.gif" border="0"></td>
          <td>geeignet mit E.</td>
          <td>wie die Art, jedoch kleiner, gleichmäßigere Krone und schnellerer Wuchs, schöne Herbstfärbung, lang haftendes Laub und Früchte, Bienenweide</td>
      </tr>
      <tr id="tr75" class="tr_edit">
          <td>Liquidambar styraciflua 'Paarl', Amberbaum</td>
          <td>15-25</td>
          <td>3-4</td>
          <td>mittel</td>
          <td><img src="img/l_1_t.gif" border="0"></td>
          <td>geeignet</td>
          <td>wie die Art, jedoch schmale, spitz-kegelförmige Krone, mittlere Wuchskraft, lang haftendes Laub und Früchte, Bienenweide, im
              <b>Straßenbaumtest 2</b>
              seit 2005</td>
      </tr>
      <tr id="tr184" class="tr_edit">
          <td>Liquidambar  styraciflua  'Worplesdon', Amberbaum</td>
          <td>10-15</td>
          <td>8-10&nbsp;(12)</td>
          <td>mittel</td>
          <td><img src="img/l_1_t.gif" border="0"></td>
          <td>noch im Test</td>
          <td>anfangs schmal, später breit kegelförmig, mittelstark wachsend, Kälte und Nässe besser vertragend als die Art, lang haftendes Laub und Früchte, Bienenweide, im
              <b>Straßenbaumtest 2</b>
              seit 2015</td>
      </tr>
      <tr id="tr76" class="tr_edit">
          <td>Liriodendron tulipifera, Tulpenbaum</td>
          <td>25-35</td>
          <td>15-20</td>
          <td>mittel</td>
          <td><img src="img/l_1_t.gif" border="0"></td>
          <td>geeignet mit E.</td>
          <td>breit kegelförmige Krone, gerader, durchgehender Leittrieb, wärmeliebend, aber frosthart, raschwüchsig, ältere Exemplare windbruchgefährdet, schöne Herbstfärbung, Bienenweide</td>
      </tr>
      <tr id="tr77" class="tr_edit">
          <td>Liriodendron tulipifera 'Fastigiata', Säulenförmiger Tulpenbaum</td>
          <td>10-15</td>
          <td>4-6</td>
          <td>gering</td>
          <td><img src="img/l_1_t.gif" border="0"></td>
          <td>geeignet mit E.</td>
          <td>wie die Art, jedoch schmalkronig, straff aufrecht wachsend, schöne Herbstfärbung, Bienenweide


          </td>
      </tr>
      <tr id="tr78" class="tr_edit">
          <td>Magnolia kobus, Baummagnolie, Kobushi-Magnolie</td>
          <td>8-10</td>
          <td>4-8</td>
          <td>mittel</td>
          <td><img src="img/l_2_t.gif" border="0"></td>
          <td>geeignet mit E.</td>
          <td>kleinkroniger Blütenbaum, breit kegelförmige Krone, Blüte vor dem Austrieb,  auf Kalkböden Chlorosegefahr, im
              <b>Straßenbaumtest 2</b>
              seit 2007/08
          </td>
      </tr>
      <tr id="tr79" class="tr_edit">
          <td>Malus spec., Zierapfelformen</td>
          <td>4-12</td>
          <td>2-6</td>
          <td>mittel</td>
          <td><img src="img/l_2_t.gif" border="0"></td>
          <td>geeignet mit E.</td>
          <td>reich blühende und fruchtende Sorten, Fruchtbehang teilweise bis in den Winter hinein, sortenbedingter Fruchtfall möglich, Lichtraumprofil beachten, für Kübel und Container geeignet, Bienenweide
          </td>
      </tr>
      <tr id="tr177" class="tr_edit">
          <td>Malus trilobata
              <br>syn. Eriolobus trilobatus, Zierapfel</td>
          <td>&nbsp;</td>
          <td>&nbsp;</td>
          <td>&nbsp;</td>
          <td>&nbsp;</td>
          <td>noch im Test</td>
          <td>siehe Eriolobus trilobatus, (im
              <b>Straßenbaumtest 2</b>
              seit 2007/08)</td>
      </tr>
      <tr id="tr84" class="tr_edit">
          <td>Malus tschonoskii, Wollapfel, Scharlach-Apfel, Pillar Appel</td>
          <td>8-12</td>
          <td>2-4</td>
          <td>mittel</td>
          <td><img src="img/l_2_t.gif" border="0"></td>
          <td>geeignet</td>
          <td>schmal kegelförmige Krone, im Alter breiter werdend, gerader durchgehender Leittrieb; Früchte gelb bis rot, geringe Schorfanfälligkeit, Bienenweide, im
              <b>Straßenbaumtest 2</b>
              seit 2005
          </td>
      </tr>
      <tr id="tr80" class="tr_edit">
          <td>Malus-Hybride 'Evereste', Zierapfel</td>
          <td>4-6</td>
          <td>3-5</td>
          <td>mittel</td>
          <td><img src="img/l_2_t.gif" border="0"></td>
          <td>geeignet mit E.</td>
          <td>breit-aufrechte Krone, im Alter überhängende Seitenäste, Lichtraumprofil beachten, kleine orangerote Früchte, geringe Schorfanfälligkeit, für Kübel und Container geeignet, Bienenweide
          </td>
      </tr>
      <tr id="tr81" class="tr_edit">
          <td>Malus-Hybride 'Red Sentinel', Zierapfel</td>
          <td>4-5</td>
          <td>3-4</td>
          <td>mittel</td>
          <td><img src="img/l_2_t.gif" border="0"></td>
          <td>geeignet mit E.</td>
          <td>schlanke Krone, tief überhängende Seitenäste, Lichtraumprofil beachten, dunkelrote Früchte, geringe Schorfanfälligkeit, für Kübel und Container geeignet, Bienenweide
          </td>
      </tr>
      <tr id="tr82" class="tr_edit">
          <td>Malus-Hybride 'Rudolph', Zierapfel</td>
          <td>5-6</td>
          <td>4-5</td>
          <td>mittel</td>
          <td><img src="img/l_2_t.gif" border="0"></td>
          <td>geeignet mit E.</td>
          <td>aufrechte Krone, später breit-eiförmig bis rundlich, Lichtraumprofil beachten, rötlicher Austrieb, später vergrünend, orangegelbe Früchte; geringe Schorfanfälligkeit, neigt zu oberflächlichen Rindenrissen, für Kübel und Container geeignet, Bienenweide</td>
      </tr>
      <tr id="tr83" class="tr_edit">
          <td>Malus-Hybride 'Street Parade', Sibirischer Apfel</td>
          <td>4-6</td>
          <td>2-3</td>
          <td>mittel</td>
          <td><img src="img/l_2_t.gif" border="0"></td>
          <td>geeignet mit E.</td>
          <td>schmal-eiförmige Krone, Lichtraumprofil beachten, geringe Mehltau- und Schorfanfälligkeit, kleine blaurote Früchte; für Kübel und Container geeignet, Bienenweide</td>
      </tr>
      <tr id="tr85" class="tr_edit">
          <td>Metasequoia glyptostroboides, Urweltmammutbaum</td>
          <td>25-35&nbsp;(40)</td>
          <td>7-10</td>
          <td>stark</td>
          <td><img src="img/l_1_t.gif" border="0"></td>
          <td>geeignet mit E.</td>
          <td>spitz kegelförmig, mit dicht verzweigter Krone, gerader, durchgehender Stamm, breit werdende Wurzelanläufe, weit reichendes Wurzelsystem, auf ausreichende Entfernung zu Straßenkanten u. ä. achten</td>
      </tr>
      <tr id="tr86" class="tr_edit">
          <td>Ostrya carpinifolia, Hopfenbuche</td>
          <td>10-15&nbsp;(20)</td>
          <td>8-12</td>
          <td>mittel</td>
          <td><img src="img/l_2_t.gif" border="0"></td>
          <td>geeignet</td>
          <td>kegelförmige, später rundliche Krone, Erscheinungsbild ähnlich Hainbuche; Früchte hopfenähnlich, dekorativ, im
              <b>Straßenbaumtest 2</b>
              seit 2005</td>
      </tr>
      <tr id="tr188" class="tr_edit">
          <td>Parrotia persica, Persischer Eisenholzbaum
          </td>
          <td>6-10&nbsp;(12)</td>
          <td>5-10</td>
          <td>gering</td>
          <td><img src="img/l_2_t.gif" border="0"></td>
          <td>noch im Test</td>
          <td>breit-rundliche bis breit-trichterförmige Krone, Blüte vor Austrieb, auffallende, attraktive Herbstfärbung, oberflächennahes Wurzelwachstum, verträgt keine Überpflasterung, im
              <b>Straßenbaumtest 2</b>
              seit 2020</td>
      </tr>
      <tr id="tr192" class="tr_edit">
          <td>Parrotia  persica  'Vanessa'
              <br>syn. P. persica 'Select', Eisenholzbaum</td>
          <td>6-10&nbsp;(12)</td>
          <td>4-6</td>
          <td>gering</td>
          <td><img src="img/l_2_t.gif" border="0"></td>
          <td>noch im Test</td>
          <td>wie die Art, jedoch mit durchgehendem Leittrieb, anspruchslos, robust, frühe Blüte, auffallende Herbstfärbung, Bodenversiegelung vermeiden, im
              <b>Straßenbaumtest 2</b>
              seit 2022</td>
      </tr>
      <tr id="tr87" class="tr_edit">
          <td>Platanus acerifolia
              <br>syn. P. x hybrida, P. hispanica, Platane</td>
          <td>20-30&nbsp;(40)</td>
          <td>15-25</td>
          <td>gering</td>
          <td><img src="img/l_1_t.gif" border="0"></td>
          <td>geeignet mit E.</td>
          <td>weit ausladende Krone, auffällige Stämme durch abblätternde Borke, anspruchslos, nicht frostempfindlich, stadtklimafest, häufig Wurzelhebungen verursachend, Laub schlecht verrottend, Befall durch Schadorganismen hat in den letzten Jahren zugenommen</td>
      </tr>
      <tr id="tr88" class="tr_edit">
          <td>Populus berolinensis, Berliner Lorbeerpyramidenpappel</td>
          <td>18-25</td>
          <td>8-10</td>
          <td>mittel</td>
          <td><img src="img/l_1_t.gif" border="0"></td>
          <td>geeignet mit E.</td>
          <td>breit säulenförmig, Äste schräg aufrecht steigend, in der Jugend kegelförmig, im Alter unregelmäßig, gerader, durchgehender Stamm, bildet Wurzelausläufer, Gefahr von Grünastbruch, Bienenweide</td>
      </tr>
      <tr id="tr187" class="tr_edit">
          <td>Populus nigra 'Italica', Pyramidenpappel, Säulenpappel, Italienische Pappel</td>
          <td>25-30&nbsp;(40)</td>
          <td>3-6</td>
          <td>gering</td>
          <td><img src="img/l_2_t.gif" border="0"></td>
          <td>geeignet</td>
          <td>schmalkronig, hoch wachsend, anspruchslos, frosthart, stadtklimafest, männliche Sorte, deshalb kein Samenflug, in zunehmendem Alter brüchig werdend, Flachwurzler, Pflanzschnitt erforderlich, um Kopflastigkeit in der Anwachsphase zu vermeiden; schnelle Wirkung durch rasches Wachstum, Bienenweide</td>
      </tr>
      <tr id="tr90" class="tr_edit">
          <td>Populus simonii
              <br>syn. P. brevifolia, Birkenpappel</td>
          <td>12-15</td>
          <td>6-8&nbsp;(10)</td>
          <td>mittel</td>
          <td><img src="img/l_1_t.gif" border="0"></td>
          <td>geeignet mit E.</td>
          <td>schmal kegelförmig, im Alter breit und rund, kurzlebig, Schneebruchgefahr durch frühen Austrieb, Gefahr von Grünastbruch, Bienenweide</td>
      </tr>
      <tr id="tr91" class="tr_edit">
          <td>Populus simonii 'Fastigiata', Säulenbirkenpappel</td>
          <td>7-10</td>
          <td>4-6</td>
          <td>mittel</td>
          <td><img src="img/l_1_t.gif" border="0"></td>
          <td>geeignet mit E.</td>
          <td>wie die Art, jedoch anfangs schmal säulenförmig, später breit-kegelförmig, verträgt Streusalz, Gefahr von Grünastbruch, Bienenweide</td>
      </tr>
      <tr id="tr92" class="tr_edit">
          <td>Populus tremula, Zitterpappel, Espe, Aspe</td>
          <td>10-20</td>
          <td>7-10</td>
          <td>mittel</td>
          <td><img src="img/l_3_t.gif" border="0"></td>
          <td>nicht geeignet</td>
          <td>lockere unregelmäßige Krone, oft schiefwüchsig und mehrstämmig, hitzeverträglich, frosthart, stadtklimaverträglich, windfest, verträgt Streusalz, starke Bildung von Wurzelausläufern, Gefahr von Grünastbruch, Bienenweide
          </td>
      </tr>
      <tr id="tr89" class="tr_edit">
          <td>Populus x canescens, Graupappel</td>
          <td>20-25&nbsp;(30)</td>
          <td>15-20&nbsp;(25)</td>
          <td>mittel</td>
          <td><img src="img/l_2_t.gif" border="0"></td>
          <td>nicht geeignet</td>
          <td>breit ausladende, unregelmäßige Krone, für landschaftlich geprägte Gebiete, bildet Wurzelausläufer, Gefahr von Grünastbruch, Bienenweide</td>
      </tr>
      <tr id="tr93" class="tr_edit">
          <td>Prunus avium, Vogelkirsche</td>
          <td>15-20&nbsp;(25)</td>
          <td>10-15</td>
          <td>gering</td>
          <td><img src="img/l_1_t.gif" border="0"></td>
          <td>nicht geeignet</td>
          <td>breite, eirunde Krone, Äste etagenförmig angeordnet, Wärme liebend, frosthart, empfindlich gegen Bodenverdichtung und Einpflastern, Gefahr von Gummifluss, Fruchtfall beachten, Bienenweide</td>
      </tr>
      <tr id="tr94" class="tr_edit">
          <td>Prunus avium 'Plena', Gefülltblühende Vogelkirsche</td>
          <td>10-15</td>
          <td>8-10</td>
          <td>gering</td>
          <td><img src="img/l_1_t.gif" border="0"></td>
          <td>geeignet mit E.</td>
          <td>wie die Art, jedoch regelmäßig pyramidale, dichte, geschlossene Krone, gefüllt blühend, keine Früchte, stadtklimafest
          </td>
      </tr>
      <tr id="tr95" class="tr_edit">
          <td>Prunus padus, Großblütige Traubenkirsche, Faulbaum</td>
          <td>10-15</td>
          <td>8-10</td>
          <td>mittel</td>
          <td><img src="img/l_2_t.gif" border="0"></td>
          <td>nicht geeignet</td>
          <td>breit kegelige Krone, breit aufstrebende Hauptäste, frosthart, windempfindlich, auffallende, stark duftende Blüte, Ausläufer bildend, empfindlich gegen Bodenverdichtung und Überpflasterung, neigt aufgrund starker Stock- und Stammaustriebe zur Mehrstämmigkeit, Bienenweide</td>
      </tr>
      <tr id="tr170" class="tr_edit">
          <td>Prunus padus 'Albertii', Traubenkirsche</td>
          <td>6-8</td>
          <td>4-5</td>
          <td>mittel</td>
          <td><img src="img/l_2_t.gif" border="0"></td>
          <td>noch im Test</td>
          <td>dicht geschlossen, anfangs breit-kegelförmig, später fast kugelrund; weit in die Krone reichender Stamm, auffallende, stark duftende Blüte, Bienenweide, im
              <b>Straßenbaumtest 2</b>
              seit 2007/08</td>
      </tr>
      <tr id="tr96" class="tr_edit">
          <td>Prunus padus 'Schloss Tiefurt', Traubenkirsche</td>
          <td>9-12</td>
          <td>6-8</td>
          <td>mittel</td>
          <td><img src="img/l_2_t.gif" border="0"></td>
          <td>geeignet</td>
          <td>wie die Art, jedoch kleiner, mit gleichmäßig geschlossener Krone, auffallend schöne und gerade Stämme bildend, auffallende, stark duftende Blüte, Bienenweide, im
              <b>Straßenbaumtest 2</b>
              seit 2005</td>
      </tr>
      <tr id="tr97" class="tr_edit">
          <td>Prunus sargentii, Scharlachkirsche,  Bergkirsche</td>
          <td>8-12</td>
          <td>5-8</td>
          <td>mittel</td>
          <td><img src="img/l_2_t.gif" border="0"></td>
          <td>geeignet mit E.</td>
          <td>breite, fächerförmige Krone, Äste trichterförmig, im Alter ausladend breitkronig, spärlich fruchtend, auffallende Herbstfärbung, Bienenweide</td>
      </tr>
      <tr id="tr180" class="tr_edit">
          <td>Prunus sargentii 'Accolade'
              <br>syn. Pr. 'Accolade', Zierkirsche</td>
          <td>5-8</td>
          <td>3-5&nbsp;(7)</td>
          <td>mittel</td>
          <td><img src="img/l_2_t.gif" border="0"></td>
          <td>geeignet mit E.</td>
          <td>rundliche bis leicht trichterförmige Krone, auf Lichtraumprofil achten, auffallende Blüte und Herbstfärbung, nicht fruchtend, Bienenweide</td>
      </tr>
      <tr id="tr98" class="tr_edit">
          <td>Prunus sargentii 'Rancho', Zierkirsche</td>
          <td>6-8</td>
          <td>3-4</td>
          <td>mittel</td>
          <td><img src="img/l_2_t.gif" border="0"></td>
          <td>geeignet mit E.</td>
          <td>wie die Art, jedoch trichterförmige Krone und kräftigere Blütenfärbung, nicht fruchtend, Lichtraumprofil beachten, Bienenweide</td>
      </tr>
      <tr id="tr178" class="tr_edit">
          <td>Prunus serrulata 'Kanzan'
              <br>syn. Pr. 'Hisakura', Pr. 'Kwanzan', Japanische Nelkenkirsche</td>
          <td>7-10&nbsp;(12)</td>
          <td>5-8</td>
          <td>mittel</td>
          <td><img src="img/l_2_t.gif" border="0"></td>
          <td>geeignet mit E.</td>
          <td>breit trichterförmige, später ausladende Krone, auffallende Blüte und Herbstfärbung, Lichtraumprofil beachten</td>
      </tr>
      <tr id="tr99" class="tr_edit">
          <td>Prunus spec., Japanische Kirsche in Arten und Sorten</td>
          <td>3-15</td>
          <td>1-10</td>
          <td>gering</td>
          <td><img src="img/l_1_t.gif" border="0"></td>
          <td>geeignet mit E.</td>
          <td>unterschiedliche Kronenformen, hoher Zierwert durch Blüte, je nach Veredelungsform Stamm- oder Wurzelaustriebe, für Kübel und Container geeignet, Bienenweide</td>
      </tr>
      <tr id="tr179" class="tr_edit">
          <td>Prunus subhirtella 'Autumnalis', Winterkirsche, Schneekirsche</td>
          <td>5-8</td>
          <td>3-5</td>
          <td>mittel</td>
          <td><img src="img/l_1_t.gif" border="0"></td>
          <td>geeignet mit E.</td>
          <td>auffallende Blüte und Herbstfärbung, Lichtraumprofil beachten, für Kübel und Container geeignet, Bienenweide</td>
      </tr>
      <tr id="tr100" class="tr_edit">
          <td>Prunus x schmittii, Zierkirsche</td>
          <td>8-10</td>
          <td>3-5</td>
          <td>mittel</td>
          <td><img src="img/l_2_t.gif" border="0"></td>
          <td>geeignet</td>
          <td>geschlossene, schmal kegelförmige Krone, Äste aufrecht wachsend, gerader durchgehender Stamm, nur kurze Zeit blühend, Fruchtfall möglich, Bienenweide</td>
      </tr>
      <tr id="tr101" class="tr_edit">
          <td>Pterocarya fraxinifolia, Kaukasische Flügelnuss</td>
          <td>10-20&nbsp;(25)</td>
          <td>10-20</td>
          <td>mittel</td>
          <td><img src="img/l_1_t.gif" border="0"></td>
          <td>nicht geeignet</td>
          <td>breit ausladende Krone, durch starke Wurzelausläuferbildung teilweise dichte Bestände bildend, schnell wachsend, spätfrostgefährdet</td>
      </tr>
      <tr id="tr171" class="tr_edit">
          <td>Pterocarya rohifolia 'Bokravention '
              <br>syn. P. rohifolia 'Kyoto Convention', Japanische Flügelnuss</td>
          <td>-10</td>
          <td>&nbsp;</td>
          <td>mittel</td>
          <td><img src="img/l_1_t.gif" border="0"></td>
          <td>noch im Test</td>
          <td>schlanke kompakte Krone, stadtklimafest, keine Ausläufer bildend, im
              <b>Straßenbaumtest 2</b>
              seit 2007/08</td>
      </tr>
      <tr id="tr102" class="tr_edit">
          <td>Pyrus calleryana 'Chanticleer', Stadtbirne, Chinesische Wildbirne</td>
          <td>8-12&nbsp;(15)</td>
          <td>4-5</td>
          <td>mittel</td>
          <td><img src="img/l_1_t.gif" border="0"></td>
          <td>geeignet mit E.</td>
          <td>schmal kegelförmige Krone, später locker, breit pyramidal, Laubfall erst nach starkem Frost (Schneebruchgefahr), vereinzelt Fruchtbildung, frühe Vergreisung, Bienenweide
          </td>
      </tr>
      <tr id="tr104" class="tr_edit">
          <td>Pyrus caucasica, Kaukasische Wildbirne</td>
          <td>8-12</td>
          <td>3-4</td>
          <td>mittel</td>
          <td><img src="img/l_2_t.gif" border="0"></td>
          <td>nicht geeignet</td>
          <td>Kegel- bis eiförmige, teils säulenförmige Krone, straff aufrecht wachsend, gerader durchgehender Stamm; Fruchtbehang, Bienenweide, teils massive Ausfälle,
              <a href="http://strassenbaumtest1.galk.de/" target="_blank">
                  <b>Ergebnisse aus Straßenbaumtest 1</b>
              </a>
              beachten</td>
      </tr>
      <tr id="tr105" class="tr_edit">
          <td>Pyrus communis 'Beech Hill', Stadtbirne</td>
          <td>8-12</td>
          <td>5-7</td>
          <td>mittel</td>
          <td><img src="img/l_2_t.gif" border="0"></td>
          <td>nicht geeignet</td>
          <td>anfänglich straff aufrecht wachsend, später kegel- bis eiförmige, teils säulenförmige Krone, feuerbrandgefährdet, gebietsweise Birnengitterrost, starke Fruchtbildung, Bienenweide, starke Vergreisungserscheinungen, teils massive Ausfälle
              <a href="http://strassenbaumtest1.galk.de/" target="_blank">
                  <b>Ergebnisse aus Straßenbaumtest 1</b>
              </a>
              beachten</td>
      </tr>
      <tr id="tr106" class="tr_edit">
          <td>Pyrus regelii, Wildbirne, Turkmenische Birne</td>
          <td>8-10</td>
          <td>7-9</td>
          <td>gering</td>
          <td><img src="img/l_2_t.gif" border="0"></td>
          <td>nicht geeignet</td>
          <td>ei- bis kugelförmige Krone, sperrige Verzweigung, feuerbrandgefährdet, gebietsweise Birnengitterrost, teilweise starke Fruchtbildung, Bienenweide, starke Vergreisungserscheinungen, teils massive Ausfälle
              <a href="http://strassenbaumtest1.galk.de/" target="_blank">
                  <b>Ergebnisse aus Straßenbaumtest 1</b>
              </a>
              beachten</td>
      </tr>
      <tr id="tr107" class="tr_edit">
          <td>Quercus cerris, Zerreiche</td>
          <td>20-30</td>
          <td>10-15&nbsp;(25)</td>
          <td>mittel</td>
          <td><img src="img/l_1_t.gif" border="0"></td>
          <td>gut geeignet</td>
          <td>stumpf kegelig, breit, durchgehender Stamm, im Alter ausladend, lang haftendes, langsam verrottendes Laub, auch auf trockenen Böden gedeihend, stadtklimafest</td>
      </tr>
      <tr id="tr193" class="tr_edit">
          <td>Quercus coccinea
              <br>syn. Q. conferta, Scharlach-Eiche</td>
          <td>15-20&nbsp;(25)</td>
          <td>8-12</td>
          <td>mittel</td>
          <td><img src="img/l_1_t.gif" border="0"></td>
          <td>noch im Test</td>
          <td>gleichmäßige, kegelförmige Krone, gerader, durchgehender Stamm, anspruchslos, auffallende Herbstfärbung, lang haftendes Laub, Bodenversiegelung vermeiden, im
              <b>Straßenbaumtest 2</b>
              seit 2022</td>
      </tr>
      <tr id="tr108" class="tr_edit">
          <td>Quercus frainetto, Ungarische Eiche</td>
          <td>10-20&nbsp;(25)</td>
          <td>10-15</td>
          <td>gering</td>
          <td><img src="img/l_2_t.gif" border="0"></td>
          <td>geeignet mit E.</td>
          <td>gleichmäßige und geschlossene Krone, oval bis rundlich, im Alter lockerer, stadtklimafest, Laub langsam verrottend, im
              <b>Straßenbaumtest 2</b>
              seit 2005</td>
      </tr>
      <tr id="tr196" class="tr_edit">
          <td>Quercus frainetto '-sämlingsvermehrt-'</td>
          <td>&nbsp;</td>
          <td>&nbsp;</td>
          <td>&nbsp;</td>
          <td>&nbsp;</td>
          <td>&nbsp;</td>
          <td>Beschreibung und Eigenschaften siehe Art, im
              <b>Straßenbaumtest 2</b>
              seit 2022</td>
      </tr>
      <tr id="tr109" class="tr_edit">
          <td>Quercus palustris, Sumpfeiche</td>
          <td>15-20&nbsp;(25)</td>
          <td>8-15&nbsp;(20)</td>
          <td>mittel</td>
          <td><img src="img/l_1_t.gif" border="0"></td>
          <td>geeignet mit E.</td>
          <td>gleichmäßige, kegelförmige Krone, gerader durchgehender Stamm, auch auf mäßig trockenen Böden gedeihend, auf Kalkböden Chlorosegefahr, Laub oft lang haftend, auffallende Herbstfärbung</td>
      </tr>
      <tr id="tr110" class="tr_edit">
          <td>Quercus petraea, Traubeneiche</td>
          <td>20-30&nbsp;(40)</td>
          <td>15-20&nbsp;(25)</td>
          <td>mittel</td>
          <td><img src="img/l_1_t.gif" border="0"></td>
          <td>geeignet</td>
          <td>regelmäßige, eiförmige Krone, tiefgrün glänzende Blätter, verträgt mehr Trockenheit als Quercus robur, Bienenweide</td>
      </tr>
      <tr id="tr111" class="tr_edit">
          <td>Quercus robur
              <br>syn. Quercus pedunculata, Stieleiche</td>
          <td>25-35&nbsp;(40)</td>
          <td>15-20&nbsp;(25)</td>
          <td>stark</td>
          <td><img src="img/l_1_t.gif" border="0"></td>
          <td>geeignet mit E.</td>
          <td>breit kegelförmige Krone, weit ausladend, lang haftendes, langsam verrottendes Laub, Pflanzung nicht vor Dezember, verträgt Überschwemmungen, reagiert auf Grundwasserabsenkung mit Wipfeldürre, frosthart, Bienenweide</td>
      </tr>
      <tr id="tr112" class="tr_edit">
          <td>Quercus robur 'Fastigiata'
              <br>syn. Quercus pedunculata 'Fastigiata', Stielsäuleneiche, Pyramideneiche</td>
          <td>15-20</td>
          <td>5-7</td>
          <td>gering</td>
          <td><img src="img/l_1_t.gif" border="0"></td>
          <td>geeignet</td>
          <td>wie die Art, jedoch säulenförmige Krone, im Alter auseinanderfallend, durch Aussaat oft nicht typische Wuchsform, Laub lang haftend; frosthart, Bienenweide</td>
      </tr>
      <tr id="tr113" class="tr_edit">
          <td>Quercus robur 'Fastigiata Koster'
              <br>syn. Quercus robusta 'Koster', Schmale Pyramideneiche</td>
          <td>15-20</td>
          <td>3-5</td>
          <td>mittel</td>
          <td><img src="img/l_2_t.gif" border="0"></td>
          <td>geeignet</td>
          <td>wie Quercus robur 'Fastigiata', jedoch auch im Alter schlanker und kompakter Wuchs, Laub lang haftend, häufig bis zum Frühjahr; frosthart, Bienenweide</td>
      </tr>
      <tr id="tr114" class="tr_edit">
          <td>Quercus rubra
              <br>syn. Quercus borealis, Amerikanische Roteiche</td>
          <td>20-25</td>
          <td>12-18&nbsp;(20)</td>
          <td>mittel</td>
          <td><img src="img/l_1_t.gif" border="0"></td>
          <td>geeignet mit E.</td>
          <td>rundliche Krone, durchgehender Leittrieb, anspruchsloser als Quercus robur, auf Kalkböden chlorotisch, stadtklimafest, lang haftendes Laub, auffallende Herbstfärbung, gebietsweise Verwilderung, Bienenweide</td>
      </tr>
      <tr id="tr115" class="tr_edit">
          <td>Robinia pseudoacacia, Robinie, Scheinakazie</td>
          <td>20-25</td>
          <td>12-18&nbsp;(22)</td>
          <td>stark</td>
          <td><img src="img/l_1_t.gif" border="0"></td>
          <td>geeignet</td>
          <td>lockere unregelmäßige Krone, in der Jugend raschwüchsig, im Alter schirmförmig; anspruchslos, windbruchgefährdet auf nährstoffreichen Böden, im Alter Totholzbildung; Blüten stark duftend, gebietsweise Verwilderung, Bienenweide
          </td>
      </tr>
      <tr id="tr116" class="tr_edit">
          <td>Robinia pseudoacacia 'Bessoniana', Kegelakazie</td>
          <td>20-25</td>
          <td>10-12&nbsp;(15)</td>
          <td>stark</td>
          <td><img src="img/l_1_t.gif" border="0"></td>
          <td>geeignet</td>
          <td>im Alter breite rundliche und dicht verzweigte Krone, meist gerader durchgehender Leittrieb, wenige und nur kleine Dornen, selten blühend, Bienenweide</td>
      </tr>
      <tr id="tr117" class="tr_edit">
          <td>Robinia pseudoacacia 'Monophylla'
              <br>syn. Robinia pseudoacacia 'Unifolia', Einblättrige Robinie</td>
          <td>15-20&nbsp;(25)</td>
          <td>8-10</td>
          <td>mittel</td>
          <td><img src="img/l_1_t.gif" border="0"></td>
          <td>geeignet mit E.</td>
          <td>unregelmäßig kegelförmige Krone, aufrechter Wuchs, Hauptäste schlank aufrecht, gerader, durchgehender Leittrieb, nur wenige kleine Dornen, Bienenweide</td>
      </tr>
      <tr id="tr118" class="tr_edit">
          <td>Robinia pseudoacacia 'Nyirsegi', Robinie, Scheinakazie</td>
          <td>25-30</td>
          <td>10-15</td>
          <td>mittel</td>
          <td><img src="img/l_1_t.gif" border="0"></td>
          <td>geeignet</td>
          <td>aufrechte, rundlich eiförmige, dicht verzweigte Krone, gerader, durchgehender Stamm bis in die Krone, wenige Dornen, geringere Bruchgefahr als die Art, Bienenweide
          </td>
      </tr>
      <tr id="tr119" class="tr_edit">
          <td>Robinia pseudoacacia 'Sandraudiga', Robinie, Scheinakazie</td>
          <td>20-25</td>
          <td>12-18&nbsp;(22)</td>
          <td>stark</td>
          <td><img src="img/l_1_t.gif" border="0"></td>
          <td>gut geeignet</td>
          <td>kegel- bis eiförmige, dichte Krone, gerader, durchgehender Stamm, rosa blühend, Bienenweide,
              <a href="http://strassenbaumtest1.galk.de/" target="_blank">
                  <b>Ergebnisse aus Straßenbaumtest 1</b>
              </a>
              beachten
          </td>
      </tr>
      <tr id="tr120" class="tr_edit">
          <td>Robinia pseudoacacia 'Semperflorens', Robinie, Scheinakazie</td>
          <td>15-20</td>
          <td>10-15&nbsp;(18)</td>
          <td>stark</td>
          <td><img src="img/l_1_t.gif" border="0"></td>
          <td>geeignet</td>
          <td>aufrechte, lockere, im Alter breit ovale Krone, geringe Bedornung, durch Nachblüte oft durchgehend von Juni bis September blühend, Bienenweide</td>
      </tr>
      <tr id="tr121" class="tr_edit">
          <td>Robinia pseudoacacia 'Umbraculifera', Kugelakazie</td>
          <td>4-6</td>
          <td>4-6</td>
          <td>gering</td>
          <td><img src="img/l_1_t.gif" border="0"></td>
          <td>geeignet</td>
          <td>dichte, kugelrunde, feintriebige Krone; im Alter mehr breit oval, Lichtraumprofil beachten, verträgt radikalen Rückschnitt, keine Blüte, für Kübel und Container geeignet
          </td>
      </tr>
      <tr id="tr122" class="tr_edit">
          <td>Salix alba, Weißweide, Silberweide</td>
          <td>15-20&nbsp;(25)</td>
          <td>10-15&nbsp;(20)</td>
          <td>stark</td>
          <td><img src="img/l_1_t.gif" border="0"></td>
          <td>nicht geeignet</td>
          <td>lockere, breite, ausladende Krone, bevorzugt feuchte Böden; Bruchgefahr, Bienenweide</td>
      </tr>
      <tr id="tr123" class="tr_edit">
          <td>Salix alba 'Liempde', Weißweide, Silberweide</td>
          <td>20-30</td>
          <td>10-12</td>
          <td>stark</td>
          <td><img src="img/l_1_t.gif" border="0"></td>
          <td>nicht geeignet</td>
          <td>wie die Art, jedoch schmal kegelförmige Krone mit aufwärts gerichteten Ästen, gerader durchgehender Stamm, Bienenweide</td>
      </tr>
      <tr id="tr124" class="tr_edit">
          <td>Sophora japonica
              <br>syn. Styphnolobium japonicum, Schnurbaum</td>
          <td>15-20&nbsp;(25)</td>
          <td>12-18&nbsp;(20)</td>
          <td>stark</td>
          <td><img src="img/l_1_t.gif" border="0"></td>
          <td>geeignet mit E.</td>
          <td>breite rundliche, sehr lockere und lichte Krone, im Alter ausladend, auf geraden, durchgehenden Stamm achten, Sommerschnitt, Jungbäume gebietsweise frostgefährdet, auffällige, späte Blüte, Bienenweide, nicht geeignet für kleine Baumscheiben</td>
      </tr>
      <tr id="tr172" class="tr_edit">
          <td>Sophora japonica 'Princeton Upright'
              <br>syn. Styphnolobium japonicum, Schnurbaum</td>
          <td>12-15</td>
          <td>7-9</td>
          <td>stark</td>
          <td><img src="img/l_1_t.gif" border="0"></td>
          <td>nicht geeignet</td>
          <td>schmaler und aufrechter wachsend als die Art, starke Wurzelaufwerfungen bei beengten Standortverhältnissen, Bienenweide; im
              <b>Straßenbaumtest 2</b>
              von 2007/08 bis 2016</td>
      </tr>
      <tr id="tr125" class="tr_edit">
          <td>Sophora japonica 'Regent'
              <br>syn. Styphnolobium japonicum, Schnurbaum</td>
          <td>15-20&nbsp;(25)</td>
          <td>10-15</td>
          <td>stark</td>
          <td><img src="img/l_1_t.gif" border="0"></td>
          <td>geeignet mit E.</td>
          <td>wie die Art, breite rundliche Krone, im Alter ausladend, Bienenweide, nicht geeignet für kleine Baumscheiben, entbehrliche Sorte, da sie keine Verbesserung zur Art darstellt,
              <a href="http://strassenbaumtest1.galk.de/" target="_blank">
                  <b>Ergebnisse aus Straßenbaumtest 1</b>
              </a>
              beachten</td>
      </tr>
      <tr id="tr126" class="tr_edit">
          <td>Sorbus aria, Mehlbeere</td>
          <td>6-12&nbsp;(18)</td>
          <td>4-7&nbsp;(12)</td>
          <td>mittel</td>
          <td><img src="img/l_1_t.gif" border="0"></td>
          <td>geeignet mit E.</td>
          <td>gleichmäßig aufgebaute kegelförmige Krone, im Alter breiter und lockerer, langsamwüchsig, Lichtraumprofil beachten, Bienenweide</td>
      </tr>
      <tr id="tr127" class="tr_edit">
          <td>Sorbus aria 'Magnifica', Mehlbeere</td>
          <td>6-12&nbsp;(18)</td>
          <td>4-7&nbsp;(12)</td>
          <td>mittel</td>
          <td><img src="img/l_1_t.gif" border="0"></td>
          <td>geeignet</td>
          <td>wie die Art, jedoch kleiner und schmaler, mit regelmäßig aufgebauter Krone, im Alter breiter, Bienenweide</td>
      </tr>
      <tr id="tr128" class="tr_edit">
          <td>Sorbus aria 'Majestica'
              <br>syn. S. aria decaisneana, Mehlbeere</td>
          <td>8-10&nbsp;(12)</td>
          <td>4-7</td>
          <td>mittel</td>
          <td><img src="img/l_1_t.gif" border="0"></td>
          <td>geeignet mit E.</td>
          <td>wie die Art, jedoch schmal kegelförmige Krone, im Alter schirmförmig, Früchte und Blätter größer, Bienenweide</td>
      </tr>
      <tr id="tr129" class="tr_edit">
          <td>Sorbus aucuparia, Eberesche, Vogelbeere</td>
          <td>6-12</td>
          <td>4-6</td>
          <td>stark</td>
          <td><img src="img/l_2_t.gif" border="0"></td>
          <td>nicht geeignet</td>
          <td>kegelförmige Krone, im Alter rundlich; Fruchtfall beachten, nicht stadtklimafest, Pioniergehölz, Bienenweide</td>
      </tr>
      <tr id="tr130" class="tr_edit">
          <td>Sorbus aucuparia 'Edulis', Essbare Eberesche</td>
          <td>10-15</td>
          <td>6-7</td>
          <td>stark</td>
          <td><img src="img/l_2_t.gif" border="0"></td>
          <td>nicht geeignet</td>
          <td>wie die Art, jedoch gleichmäßige, geschlossene und schlanke Krone, größere, essbare Früchte, Fruchtfall beachten, Bienenweide, nicht stadtklimafest</td>
      </tr>
      <tr id="tr131" class="tr_edit">
          <td>Sorbus intermedia
              <br>syn. Sorbus suecica, Schwedische Mehlbeere, Oxelbeere</td>
          <td>10-15&nbsp;(20)</td>
          <td>5-7</td>
          <td>mittel</td>
          <td><img src="img/l_1_t.gif" border="0"></td>
          <td>geeignet mit E.</td>
          <td>kegelförmige Krone, im Alter rundlich, Lichtraumprofil beachten, Bienenweide</td>
      </tr>
      <tr id="tr132" class="tr_edit">
          <td>Sorbus intermedia 'Brouwers', Schwedische Mehlbeere, Oxelbeere</td>
          <td>9-12</td>
          <td>4-7</td>
          <td>gering</td>
          <td><img src="img/l_1_t.gif" border="0"></td>
          <td>geeignet</td>
          <td>wie die Art, jedoch kompakte pyramidale Krone, gerader durchgehender Stamm, stadtklimafest, windfest, frosthart, Bienenweide, Lichtraumprofil beachten</td>
      </tr>
      <tr id="tr173" class="tr_edit">
          <td>Sorbus latifolia 'Henk Vink', Breitblättrige Mehlbeere</td>
          <td>8-12</td>
          <td>4-6</td>
          <td>mittel</td>
          <td><img src="img/l_2_t.gif" border="0"></td>
          <td>noch im Test</td>
          <td>schmale, pyramidale, geschlossene Krone, stadtklimafest, windverträglich, Bienenweide, Lichtraumprofil beachten, für Straßenbaumtest 2 vorgesehen, Lichtraumprofil beachten, im
              <b>Straßenbaumtest 2</b>
              seit 2018</td>
      </tr>
      <tr id="tr133" class="tr_edit">
          <td>Sorbus x thuringiaca 'Fastigiata', Thüringische Säulen - Mehlbeere</td>
          <td>5-7</td>
          <td>4-5</td>
          <td>mittel</td>
          <td><img src="img/l_1_t.gif" border="0"></td>
          <td>geeignet</td>
          <td>schmale, kegelförmige und kompakte Krone; stadtklimafest, frosthart, trockenheitsverträglich, langsam wachsend, Bienenweide, Lichtraumprofil beachten</td>
      </tr>
      <tr id="tr134" class="tr_edit">
          <td>Tilia americana 'Nova'
              <br>syn. T. flaccida 'Nova', Amerikanische Linde</td>
          <td>25-30</td>
          <td>15-20</td>
          <td>gering</td>
          <td><img src="img/l_2_t.gif" border="0"></td>
          <td>geeignet</td>
          <td>breit kegelförmige Krone, im Alter rundlich, gerader, durchgehender Stamm, vergleichsweise große Blätter, Honigtauabsonderung, frosthart, hitzeverträglich, Bienenweide</td>
      </tr>
      <tr id="tr135" class="tr_edit">
          <td>Tilia cordata, Winterlinde, Steinlinde</td>
          <td>18-20&nbsp;(30)</td>
          <td>12-15&nbsp;(20)</td>
          <td>gering</td>
          <td><img src="img/l_2_t.gif" border="0"></td>
          <td>geeignet mit E.</td>
          <td>sehr stark duftend, Habitus kann sehr variabel sein, daraus resultiert ein schwieriger Kronenaufbau, schwer aufzuasten, Honigtauabsonderung

          </td>
      </tr>
      <tr id="tr136" class="tr_edit">
          <td>Tilia cordata 'Erecta'
              <br>syn. T. cordata 'Böhlje', Dichtkronige Winterlinde</td>
          <td>15-20</td>
          <td>10-12&nbsp;(14)</td>
          <td>gering</td>
          <td><img src="img/l_2_t.gif" border="0"></td>
          <td>geeignet</td>
          <td>wie die Art, jedoch mit kleiner und regelmäßiger Krone, kleine Blätter, als junger Baum langsam wachsend, Bienenweide</td>
      </tr>
      <tr id="tr137" class="tr_edit">
          <td>Tilia cordata 'Greenspire', Amerikanische Stadtlinde</td>
          <td>18-20</td>
          <td>10-12</td>
          <td>gering</td>
          <td><img src="img/l_2_t.gif" border="0"></td>
          <td>gut geeignet</td>
          <td>schmale, regelmäßige und dichte Krone, im Alter breiter, Äste aufsteigend,  stadtklimafest, Honigtauabsonderung, Bienenweide</td>
      </tr>
      <tr id="tr138" class="tr_edit">
          <td>Tilia cordata 'Rancho', Amerikanische Stadtlinde</td>
          <td>8-12&nbsp;(15)</td>
          <td>4-6&nbsp;(8)</td>
          <td>gering</td>
          <td><img src="img/l_2_t.gif" border="0"></td>
          <td>gut geeignet</td>
          <td>wie die Art, jedoch mit kegelförmiger, dichter, regelmäßiger Krone, Äste aufrecht bis überhängend, langsam und kompakt wachsend; geringere Honigtauabsonderung, Bienenweide,
              <a href="http://strassenbaumtest1.galk.de/" target="_blank">
                  <b>Ergebnisse aus Straßenbaumtest 1</b>
              </a>
              beachten
          </td>
      </tr>
      <tr id="tr139" class="tr_edit">
          <td>Tilia cordata 'Roelvo', Winterlinde, Stadtlinde</td>
          <td>10-15</td>
          <td>7-10</td>
          <td>gering</td>
          <td><img src="img/l_2_t.gif" border="0"></td>
          <td>gut geeignet</td>
          <td>wie die Art, jedoch kegel- bis eiförmige Krone, langtriebiger und nicht so kompakt wachsend wie 'Rancho', Honigtauabsonderung, Bienenweide,
              <a href="http://strassenbaumtest1.galk.de/" target="_blank">
                  <b>Ergebnisse aus Straßenbaumtest 1</b>
              </a>
              beachten</td>
      </tr>
      <tr id="tr142" class="tr_edit">
          <td>Tilia platyphyllos, Sommerlinde</td>
          <td>30-35&nbsp;(40)</td>
          <td>18-25</td>
          <td>gering</td>
          <td><img src="img/l_2_t.gif" border="0"></td>
          <td>nicht geeignet</td>
          <td>breit eiförmige Krone, ausladende Seitenäste; verlangt tiefgründige, frische, humose Böden, empfindlich gegen Bodenverdichtung, nicht für das innerstädtische Klima geeignet, Honigtauabsonderung, Bienenweide</td>
      </tr>
      <tr id="tr143" class="tr_edit">
          <td>Tilia platyphyllos 'Rubra', Korallenrote Sommerlinde</td>
          <td>30-35</td>
          <td>15-20</td>
          <td>gering</td>
          <td><img src="img/l_2_t.gif" border="0"></td>
          <td>nicht geeignet</td>
          <td>wie die Art, jedoch regelmäßigere breit kegelförmige Krone, Triebspitzen auffallend orange- bis korallenrot gefärbt im Winter, einjährige Triebe intensiv rot, Honigtauabsonderung, Bienenweide</td>
      </tr>
      <tr id="tr144" class="tr_edit">
          <td>Tilia tomentosa, Silberlinde</td>
          <td>25-30</td>
          <td>15-20</td>
          <td>gering</td>
          <td><img src="img/l_1_t.gif" border="0"></td>
          <td>geeignet mit E.</td>
          <td>regelmäßige, breit kegelförmige, geschlossene Krone, Neigung zu Gabelwuchs; späte Blütentracht, Bienenweide, weder bienen- noch hummelgefährlich, keine Honigtauabsonderung, schwer aufastbar, die Verwendung von Sorten wird empfohlen</td>
      </tr>
      <tr id="tr145" class="tr_edit">
          <td>Tilia tomentosa 'Brabant', Brabanter Silberlinde</td>
          <td>20-25&nbsp;(30)</td>
          <td>12-18&nbsp;(20)</td>
          <td>gering</td>
          <td><img src="img/l_1_t.gif" border="0"></td>
          <td>gut geeignet</td>
          <td>breite kegelförmige dichte und regelmäßig aufgebaute Krone, Selektion mit besserer Leittriebbildung als die Art, keine Honigtauabsonderung, Bienenweide</td>
      </tr>
      <tr id="tr174" class="tr_edit">
          <td>Tilia tomentosa 'Szeleste', Ungarische Silberlinde</td>
          <td>20-25</td>
          <td>12-15</td>
          <td>gering</td>
          <td><img src="img/l_2_t.gif" border="0"></td>
          <td>noch im Test</td>
          <td>gleichmäßige, schmal eiförmige, später breit eiförmige Krone, Selektion mit besserer Leittriebbildung als die Art, stadtklimafest, verträgt, im Gegensatz zu anderen Linden, längere Bodentrockenzeiten und Nährstoffarmut, keine Honigtauabsonderung, Bienenweide, im
              <b>Straßenbaumtest 2</b>
              seit 2007/08</td>
      </tr>
      <tr id="tr140" class="tr_edit">
          <td>Tilia x euchlora
              <br>syn. Tilia x europaea 'Euchlora', Krimlinde</td>
          <td>15-20&nbsp;(25)</td>
          <td>10-12</td>
          <td>mittel</td>
          <td><img src="img/l_1_t.gif" border="0"></td>
          <td>geeignet</td>
          <td>stumpf kegelförmige Krone, gerader, durchgehender Stamm, stark hängende Äste, Lichtraumprofil beachten, schnellwachsend, früher Austrieb, windfest, frosthart, Honigtauabsonderung, Bienenweide
          </td>
      </tr>
      <tr id="tr146" class="tr_edit">
          <td>Tilia x europaea
              <br>syn. T. x intermedia, T. x vulgaris, T. hollandica, Holländische Linde</td>
          <td>25-35&nbsp;(40)</td>
          <td>15-20</td>
          <td>gering</td>
          <td><img src="img/l_1_t.gif" border="0"></td>
          <td>geeignet</td>
          <td>gleichmäßig aufgebaute kegelförmige Krone, stadtklimafest, trockenheitsverträglich und wärmeliebend, Honigtauabsonderung, Bienenweide</td>
      </tr>
      <tr id="tr147" class="tr_edit">
          <td>Tilia x europaea 'Pallida'
              <br>syn. T. x intermedia 'Pallida', T. x vulgaris 'Pallida', Kaiserlinde</td>
          <td>30-35&nbsp;(40)</td>
          <td>12-18&nbsp;(20)</td>
          <td>gering</td>
          <td><img src="img/l_1_t.gif" border="0"></td>
          <td>gut geeignet</td>
          <td>wie die Art, jedoch gleichmäßig kegelförmige Krone, im Alter breit ausladend; Blätter haften im Herbst länger als bei der Art, verschiedene Selektionen im Handel; Honigtauabsonderung, Bienenweide</td>
      </tr>
      <tr id="tr141" class="tr_edit">
          <td>Tilia x flavescens 'Glenleven', Kegellinde</td>
          <td>15-20&nbsp;(25)</td>
          <td>12-15</td>
          <td>gering</td>
          <td><img src="img/l_1_t.gif" border="0"></td>
          <td>gut geeignet</td>
          <td>kegel- bis säulenförmige, geschlossene Krone, durchgehender Stamm, schnellwachsend, stadtklimafest, Honigtauabsonderung, Bienenweide,
              <a href="http://strassenbaumtest1.galk.de/" target="_blank">
                  <b>Ergebnisse aus Straßenbaumtest 1</b>
              </a>
              beachten
          </td>
      </tr>
      <tr id="tr148" class="tr_edit">
          <td>Ulmus glabra, Bergulme</td>
          <td>25-35&nbsp;(40)</td>
          <td>15-20</td>
          <td>mittel</td>
          <td><img src="img/l_1_t.gif" border="0"></td>
          <td>nicht geeignet</td>
          <td>rundliche, breit ausladende und dichte Krone, anspruchsvoll bezüglich Wasser- und Nährstoffversorgung, Bienenweide, anfällig für die Ulmenkrankheit</td>
      </tr>
      <tr id="tr194" class="tr_edit">
          <td>Ulmus laevis
              <br>syn. U. pedunculata, U. racemosa, U. effusa, Flatterulme, Rispenulme</td>
          <td>25-30&nbsp;(40)</td>
          <td>10-20&nbsp;(25)</td>
          <td>mittel</td>
          <td><img src="img/l_2_t.gif" border="0"></td>
          <td>noch im Test</td>
          <td>breit säulenförmige, später ausladende Krone, im Alter Stützwurzeln (Brettwurzeln) ausbildend, nicht zu trockene Standorte, widerstandsfähig gegen die Ulmenkrankheit,Bienenweide, im
              <b>Straßenbaumtest 2</b>
              seit 2022</td>
      </tr>
      <tr id="tr195" class="tr_edit">
          <td>Ulmus pumila
              <br>syn. U. manshurica, U. turkestania, Sibirische Ulme</td>
          <td>15-20&nbsp;(30)</td>
          <td>10-20&nbsp;(25)</td>
          <td>mittel</td>
          <td><img src="img/l_1_t.gif" border="0"></td>
          <td>noch im Test</td>
          <td>hohe, ausladende, unregelmäßige Krone, markante Borke bei älteren Bäumen, hitzeverträglich, Trockenheit, aber auch kurzzeitige Überflutungen vertragend, sehr anpassungsfähig, widerstandsfähig gegen Ulmenkrankheit, im
              <b>Straßenbaumtest 2</b>
              seit 2022</td>
      </tr>
      <tr id="tr153" class="tr_edit">
          <td>Ulmus x hollandica 'Lobel', Schmalkronige Stadtulme</td>
          <td>12-15</td>
          <td>4-5</td>
          <td>gering</td>
          <td><img src="img/l_1_t.gif" border="0"></td>
          <td>geeignet mit E.</td>
          <td>anfangs schmal aufrecht wachsende, säulenförmige Krone, später mehr kegelförmig, breiter werdend, starkwüchsig, geringere Anfälligkeit gegenüber Ulmenkrankheit, Käferbefall jedoch möglich
          </td>
      </tr>
      <tr id="tr149" class="tr_edit">
          <td>Ulmus-Hybride 'Clusius', Ulme, Rüster</td>
          <td>15-18</td>
          <td>5-10</td>
          <td>gering</td>
          <td><img src="img/l_2_t.gif" border="0"></td>
          <td>noch im Test</td>
          <td>breit säulenförmige Krone, im Alter breit eiförmig, schnell wachsend, geringere Anfälligkeit gegen die Ulmenkrankheit, Käferbefall jedoch möglich, im
              <b>Straßenbaumtest 2</b>
              seit 2005</td>
      </tr>
      <tr id="tr150" class="tr_edit">
          <td>Ulmus-Hybride 'Columella', Säulen - Ulme</td>
          <td>15-20</td>
          <td>5-10</td>
          <td>gering</td>
          <td><img src="img/l_2_t.gif" border="0"></td>
          <td>noch im Test</td>
          <td>aufrechte bis säulenförmiger Krone, auffallend schlank, dunkelgrünes, auffallend gekräuseltes Blatt; bisher keine genauen Angaben von ausgewachsenen Bäumen vorhanden, vermutlich resistent gegen die Ulmenkrankheit, Käferbefall jedoch möglich, im
              <b>Straßenbaumtest 2</b>
              seit 2007/08</td>
      </tr>
      <tr id="tr151" class="tr_edit">
          <td>Ulmus-Hybride 'Dodoens', Ulme, Rüster</td>
          <td>12-15</td>
          <td>5-6</td>
          <td>gering</td>
          <td><img src="img/l_2_t.gif" border="0"></td>
          <td>geeignet mit E.</td>
          <td>lockere, schlank aufrechte Krone, im Alter breit kegelförmig, geringere Anfälligkeit gegen die Ulmenkrankheit, Käferbefall jedoch möglich</td>
      </tr>
      <tr id="tr152" class="tr_edit">
          <td>Ulmus-Hybride 'New Horizon', Schmalkronige Stadtulme</td>
          <td>20-25</td>
          <td>5-6</td>
          <td>gering</td>
          <td><img src="img/l_2_t.gif" border="0"></td>
          <td>geeignet mit E.</td>
          <td>säulen- bis kegelförmige dichte Krone, im Jugendstadium schmal kegelförmig, später breiter, vermutlich hohe Resistenz gegen Ulmenkrankheit, Käferbefall jedoch möglich, im
              <b>Straßenbaumtest 2</b>
              seit 2007/08</td>
      </tr>
      <tr id="tr154" class="tr_edit">
          <td>Ulmus-Hybride 'Rebona', Rebona - Ulme</td>
          <td>15-20</td>
          <td>10-15</td>
          <td>gering</td>
          <td><img src="img/l_2_t.gif" border="0"></td>
          <td>geeignet mit E.</td>
          <td>breit kegelförmige Krone, Äste flach abstehend, vermutlich resistent gegen Ulmenkrankheit, Käferbefall jedoch möglich</td>
      </tr>
      <tr id="tr155" class="tr_edit">
          <td>Ulmus-Hybride 'Regal', Ulme, Rüster</td>
          <td>15-20</td>
          <td>6-8</td>
          <td>mittel</td>
          <td><img src="img/l_1_t.gif" border="0"></td>
          <td>geeignet mit E.</td>
          <td>anfangs schmal kegelförmig, im Alter breit säulenförmig, schnell wachsend, vermutlich resistent gegen Ulmenkrankheit, Käferbefall jedoch möglich, im
              <b>Straßenbaumtest 2</b>
              seit 2007/08; Hinweis: Wird nur noch in relativ geringen Mengen für Nachpflanzungen gezogen.</td>
      </tr>
      <tr id="tr156" class="tr_edit">
          <td>Zelkova serrata
              <br>syn. Z. acuminata, Z. keaki, Japanische Zelkove</td>
          <td>20-25</td>
          <td>15-25</td>
          <td>gering</td>
          <td><img src="img/l_2_t.gif" border="0"></td>
          <td>geeignet mit E.</td>
          <td>breit, runde Krone mit weit ausladendendem Wuchs, auf geraden, durchgehenden Leittrieb achten, stadtklimafest, im
              <b>Straßenbaumtest 2</b>
              seit 2005</td>
      </tr>
      <tr id="tr176" class="tr_edit">
          <td>Zelkova serrata 'Green Vase', Japanische Zelkove</td>
          <td>15-18</td>
          <td>-12</td>
          <td>gering</td>
          <td><img src="img/l_2_t.gif" border="0"></td>
          <td>noch im Test</td>
          <td>anfangs aufrecht, später breit trichterförmig, insgesamt schmaler als die Art, stadtklimafest, aber spätfrostgefährdet, im
              <b>Straßenbaumtest 2</b>
              seit 2007/08</td>
      </tr>
  </tbody>
</table>`;
}
